export const ENGLISH_TRANSLATIONS = {
  text: {
    retainership: {
      resetExpiryDate: "Reset Expiry Date",
      resetSuccessful: "Reset Successful",
      sellToCustomer: "Sell to Customer",
      approveRequest: "Approve Request",
      orderDate: "Order Date",
      orderAmount: "Order Amount",
      cardRequest: "Card Request",
      numberOfCards: "Number of requested cards",
      issuedCard: "Total Issued cards",
      unissuedCard: "Total Unissued cards",
      availableCards: "Available Cards",
      setCardCharge: "Set Card Charge",
      enterAmount: "Enter an  amount",
      assignCard: "Assign Card",
      selectCustomer: "Select customer",
      selectCard: "Select Card",
      totalCards: "Total Cards",
      cardList: "List of Available Cards",
      selectAllCards: "Select needed number of Cards",
      currentCardCharge: "Current card charge",
      walletTopup: "Wallet Top Up",
      selectClient: "Select Client",
      selectChargeMode: "Select Charge  Mode",
      billClient: "Bill client for payment",
      dontBill: "Don't bill client",
      walletUpdatedSuccesfully: "Wallet Updated Successfully",
      enterAmount: "Enter Amount",
      assignedSuccess: "Assigned Successfully",
      accountProvider: "Account Provider",
      assignedTo: "Assigned To",
      activated: "Activated",
      nameOnCard: "Name on Card",
      linkedTerminals: "Linked Terminals",
      nonLinkedTerminals: "Non-Linked Terminals",
      walletHistory: "Wallet History",
      channel: "Channel",
      pendingRequest: "Pending Requests",
    },

    //posRevamp
    posRevamp: {
      selectVendor: "Select Vendor",
      fee: "Fee",
      transactionLimit: "Transaction Limit",
    },

    // Products In Portal
    products: {
      enterAmount: "Enter amount to settlement",
      settle: "Settle",
      sureDeleteRequest: "Are you sure you want to delete this request?",
      requestDeleted: "Request Deleted Successfully",
      updateBankRequest: "Update Bank Request",
      requestSent: "Request Sent Successfully",
      efueling: "Efueling",
      priceUpdate: "Price Update",
      itemsPerPage: "Items per page",
      total: "TOTAL",
      productDischarged: "Product Discharged",
      productDischargedOn: "Product Discharged On",
      totalVolume: "Total Volume",
      productsVolumeDetails: "Products Volume Details",
      ltrs: "Ltrs",
      productsDischargedOn: "Products Discharged On",
      product: "Product",
      plateNumber: "Plate Number",
      stockValuation: "Stock Valuation",
      noStockValuation: "No stocks valuation recorded",
      currentVolume: "Current Volume:",
      valuation: "Valuation",
      manageProducts: "Manage Products",
      manageProductHere: "Manage your products here...",
      createProduct: "Create Product",
      totalProducts: "Total products",
      programName: "Program name",
      name: "Name",
      desc: "Description",
      quantityPerUnit: "Quantity per unit",
      productCategory: "Product category",
      action: "Action",
      productDischarged: "Products Discharged",
      productDischargedOn: "Products Discharged on",
      plateNumber: "Plate Number",
      val: "valuation:",
      retailOutlets: "Retail Outlets",
      seeProductsStock: "See Product Stock",
      totalStock: "Total Stock",
      totalQuantitySupplied: "Total Quantity Supplied",
      totalQuantitySold: "Total Quantity Sold",
      productName: "Product Name",
      quantitySupplied: "Quantity supplied",
      quantitySold: "Quantity sold",
      updated: "Updated",
      added: "Added",
    },
    // Vue-ctk-date-picker
    calendar: {
      today: "Today",
      yesterday: "Yesterday",
      last7Days: "Last 7 Days",
      lastWeek: "Last Week",
      last30Days: "Last 30 Days",
      lastMonth: "Last Month",
      dateRange: "Select a Date Range",
      selectDate: "Select a Date",
      selectDateAndTime: "Select schedule date and time",
      date: "Date",
      time: "Time",
      from: "From",
      to: "To",
      dateTime: "Date/Time",
    },
    // Action Buttons For Table
    actionButtons: {
      title: "Action",
      edit: "Edit",
      delete: "Delete",
      submit: "Submit",
      upload: "Upload File",
      select: "Select",
      exportPdf: "Export PDF",
      cancel: "Cancel",
      ok: "Ok",
      update: "Update",
      fund: "Fund",
      status: "Status",
      page: "Page",
    },
    // Click buttons
    clickButtons: {
      status: "Status",
      details: "Details",
      viewAsset: "View Asset",
      viewGroup: "View group",
      unLinkVehicle: "Unlink Vehicle",
      viewDetails: "View Details",
      maintenance: "Maintenance",
      tankDetails: "View Tank Details",
      toDashboard: "Go to Dashboard",
      unmapFromGroup: "Unmap from Group",
      reject: "Reject",
      close: "Close",
      startShift: "Start Shift",
      deleteFault: "Delete Fault",
      editMaintenance: "Edit Maintenance",
      maxCash: "Maximum Cash Amount",
      paymentRecords: "Payment records",
      parentAssets: "Parent Assets",
      addFile: "Add File",
      recordService: "Record Service",
      renewItem: "Renew Item",
      supplyHistory: "Supply history",
      salesHistory: "Sales history",
      acceptSupply: "Accept supply",
      seeReason: "see reason",
      companies: "companies",
      transactionHistory: "Transactions history",
      addTransaction: "Add transaction",
      companyDetails: "Company details",
      gensysDetails: "Gensys details",
      viewBreakDown: "View breakdown",
      view: "View",
      reAssignPos: "Re-assign POS",
      viewHistory: "View History",
      branches: "Branches",
      mapToBranch: "Map To Branch",
      mapToSite: "Map To Site",
      users: "Users",
      mapUsersToGroup: "Map User(s) to Group",
      mapBranchesToView: "Map Branches To View",
      mapBranchesToViewDashboard: "Map Branche(s) To View Dashboard",
      viewDashboard: "View Dashboard",
      sites: "Sites",
      mapSitesToView: "Map Sites To View",
      download: "Download",
      viewBranches: "View Branches",
      mapBranchesToViewList: "Map Branches To View List",
      forward: "Forward",
      fundAccount: "Fund Account",
      vouchersBy: "Vouchers by",
      refresh: "Refresh",
      send: "Send",
      resend: "Resend",
      remove: "Remove",
    },
    // Password Prompt
    passwordPrompt: {
      pleaseInput: "Please input your password",
      cancel: "Cancel",
      submit: "Submit",
      password: "Password",
    },
    // And Text
    and: {
      text: "and",
    },
    of: {
      text: "of",
    },
    for: {
      text: "for",
    },
    units: {
      litres: "Ltrs",
    },
    //errors
    errors: {
      selectDate: "Select date",
      bankMissing: "Please select a bank",
      amountError: "Enter an amount",
      emailMissing: "Please input an email",
      invalidEmail: "Invalid Email Format",
      nameMissing: "Please input a Name",
      firstNameMissing: "Please input a First Name",
      lastNameMissing: "Please input a Last Name",
      passwordMissing: "Please input your password",
      priceFieldMissing: "Please input a price",
      productMissing: "Please select a product",
      contactNameMissing: "Please input a contact name",
      cityMissing: "Please input a city",
      streetMissing: "Please input a street",
      stateMissing: "Please select a state",
      contactPhoneMissing: "Please input a phone number",
      shortPhoneNumber: "Phone number should be between 10 and 13 digits",
      shortPassword: "Password should be between 8 and 100 characters",
      accountNameMissing: "Please input an account name",
      accountNumberMissing: "Please input an account number",
      dateMissing: "Please select a date",
      invalidPrice: "Please input a price greater than 0",
      confirmPassword: "Confirm your password",
      passwordMatch: "Password must match",
      networkError: "Network Error, Please Check Your Internet Connection",
      errorOccured: "An Error Occured",
      accessDenied: "Access Denied",
      noAccess:
        "The page you are trying to access can't be granted,you can contact admin for support.",
      descIsRequired: "Description is required",
      pleaseSelectCategory: "Please select a category",
      enterQuantityUnit: "Please enter quantity per unit",
      nameIsRequired: "Name is required",
      productUpdatedSuccessfully: "Product updated successfully",
      productCreatedSuccessfully: "Product created successfully",
      selectBranch: "Please select a branch",
      nwProductCreated: "Non wet product supply created successfully",
      propertyNameRequired: "Property name is required",
      propertyDescriptionRequired: "Property description is required",
      rentFeeRequired: "Rent fee is required",
      restroomRequired: "number of rest rooms is required",
      roomsRequired: "number of rooms is required",
      detailsRequired: "Additional details is required",
      rentDurationRequired: "Rent duration is required",
      updatedBranchSpace: "Successfully updated station space",
      unitPriceRequired: "Unit price is required",
      transAddedSuccess: "Transactions added successfully",
      driverNameReq: "Divers Name is required",
      emailIsRequired: "Email is required",
      inputPhoneNo: "Please input a phone no",
      hasBeenUnmappedSuccess: "has been unmapped successfully from",
      sureWantUnmap: "Are you sure you want to unmap",
      enterAcctType: " Please select an account type",
      enterAmount: "Enter an amount",
    },
    // General Form
    form: {
      name: "Name",
      firstName: "First Name",
      lastName: "Last Name",
      fullName: "Full name",
      address: "Address",
      phoneNo: "Phone Number",
      email: "Email",
      state: "State",
      date: "Date",
      country: "Country",
      status: "Status",
      product: "Product",
      user: "User",
      volume: "Volume",
      amount: "Amount",
      code: "Code",
      city: "City",
      category: "Category",
      desc: "Description",
      action: "Action",
      city: "City",
      company: "Company",
      contactEmail: "Contact email",
      contactPhone: "Contact phone",
    },
    // General
    general: {
      company: "Fuelmetrics",
      country: "Nigeria",
      state: "Lagos",
      rating: "Rating",
      na: "N/A",
      ussd: "USSD",
      first: "First",
      last: "Last",
    },
    // Requests
    requests: {
      settementSuccessful: "Settlement Successful",
      success: "Request Successful",
      failure: "Request Failed",
      pending: "Request Pending",
      network: "Network Failure",
      downloadSuccess: "Download Successful",
      responseCode: "Response Code",
    },
    // Subscription
    subscribe: {
      expireIn: "YOUR SUBSCRIPTION WILL EXPIRE in",
      makePayment: "PLEASE MAKE PAYMENT",
      expired: "YOUR SUBSCRIPTION HAS EXPIRED, PLEASE MAKE PAYMENT",
    },

    /***Company Portal */
    // Company Master Layout
    cMasterLayout: {
      selectLanguage: "Select Language",
      manageCompanies: "Manage Companies",
      mgtDesc:
        "You can drill down to companies to manage any company account here",
      bankAcctRequest: "Bank Account Request",
      dashboard: "Dashboard",
      stationManagement: "Station Management",
      priceManagement: "Price Management",
      updatePrice: "Update Price",
      report: "Report",
      companySales: "Company Sales",
      sales: "Sales",
      varianceReport: "Variance Report",
      tanksFilledReport: "Product Discharged Report",
      posReport: "POS Transactions Report",
      peddlingManagement: "Peddling Management",
      peddling: "Peddling",
      orders: "Orders",
      products: "Products",
      manageDrivers: "Manage Drivers",
      manageTrucks: "Manage Trucks",
      ourDealers: "Our Dealers",
      retailOutlets: "Retail Outlets",
      corporateCustomers: "Corporate Customers",
      retainership: "Retainership",
      walletFundRequest: "Wallet Fund Request",
      customers: "Customers",
      manageExpenses: "Manage Expenses",
      expenses: "Expenses",
      categories: "Expense Categories",
      bankAccounts: "Bank Accounts",
      zones: "Regions",
      outstandingPayments: "Outstanding Payments",
      payments: "Payments",
      signOut: "Sign Out",
      confirmLogout: "Do you really want to logout?",
      profile: "Profile",
      SubExpire: "YOUR SUBSCRIPTION WILL EXPIRE in",
      makePayment: ", PLEASE MAKE PAYMENT",
      subHasExpired: "YOUR SUBSCRIPTION HAS EXPIRED, PLEASE MAKE PAYMENT",
      profile: "Profile",
      logOut: "Logout",
      supportAdmin: "Support Admin",
      invoices: "Invoices",
      wallet: "Wallet",
      drivers: "Drivers",
      managePeddling: "Manage Peddling",
      loyalty: "Loyalty",

      alertsAlarms: "Alerts And Alarms",
      trucksDrivers: "Trucks And Drivers",
      maintenance: "Maintenance",
      waybill: "Waybill",
      aggregatedCompanyFault: "Aggregated Company Faults",
      shutdownPumps: "Shutdown pumps",
      companyWallet: "Company Wallet",
      assetGroup: "Asset Groups",
      regions: "Manage Regions",
      branchWalletTransactions: "Station Wallet Transactions",
      transactionSalesCount: "Transaction Sales Count",
      management: "Management",
      manageUsers: "Manage Users",
      subscriptionTransactions: "Subscription transactions",
      recurringPayment: "Set up recurring payment",
      posTerminals: "POS Terminals",
      bankTrans: "Bank transactions",
      bankDeposit: "Bank deposits",
      bank: "Bank",
      sufficiencyMetrics: "Sufficiency Metrics",
      dealers: "Dealers",
      groupManagement: "Group Management",
      category: "Categories",
      branchProduct: "Station product stock",
      supplies: "Supplies",
      dryStock: "Dry stock",
      branchLease: "Station rents",
      services: "Services",
      manualRecords: "Manual records",
      dailyBranchTransactions: "Daily station transactions",
      sendBranchReport: "Send station report",
      stockValuation: "Stock Valuation ",
      productsReceived: "Products Received",
      tankVariance: "Tank variance",
      tanksFilled: "Tanks Filled",
      cashflow: "Cash Flow",
      tankStock: "Tank Stock",
      companySalesSummary: "Company Sales Summary",
      productsDischarged: "Products Discharged",
      faults: "Faults",
      contactCom: "Contact your company to make necessary payment",
    },
    // Company Dashboard
    cDashboard: {
      salesVTarget: "Sales vs Target",
      dealers: "Dealers",
      branches: "Stations",
      tanksFilled: "Product Discharged ",
      totalPumps: "Total Number Of Pumps",
      disconnectedPumps: "Number Of Disconnected Pumps",
      duration: "Duration",
      offlinePumps: "Number Of Pumps Offline",
      lowTanksTitle: "Tanks with less than 30% of their capacity",
      curVolume: "Current Volume",
      maxVolume: "Maximum Volume",
      showAllButton: "Show All",
      todaySalesTransactions: "Company Sales Transactions for",
      branch: "Station",
      productVolume: "Volume (ltr)",
      productAmount: "Amount {currency}",
      total: "Total {currency}",
      nA: "N/A",
      tanK: "Product Stock",
      pms: "PMS",
      ltrs: "Ltrs",
      lpg: "LPG",
      ago: "AGO",
      dpk: "DPK",
      tankVariance: "Tank variance",
      branchName: "Station Name",
      pmsVolume: "PMS volume",
      agoVolume: "AGO Volume",
      dpkVolume: "DPK Volume",
      lpgVolume: "LPG Volume:",
      branchTank: "Station Tank Stock and Projection",
      noTank:
        "No Tank  is running low, all Tanks current can still last for the next 48 hours",
      saleprojection: "48hrs Sale projection:",
      volProjection: "48hrs Vol Projection",
      saleTransactionToday: "Dealer Sales Transaction Today",
      branchSales: "Station sales",
      state: "State",
      region: "Region",
      salesReport: "Sales Report",
      stations: "Stations",
      productDischarged: "Product Discharged",
      //NEW
      companyDashboard: "Company Dashboard",
      productInventory: "Product Inventory",
      transactionCount: "Transaction Count",
      tankStockProjection: "Station Tank Stock and Projection",
      noLowTanks:
        " No Tank is running low, All Tanks can last for the next 48 hours",
      salesProjection: "48hrs Sales projection",
      volProjection: "48hrs Vol projection",
      offlinePumps: "Number Of Pumps Offline",
      lowTanksTitle: "Tanks with less than 30% of their capacity",
      station: "Station",
      state: "State",
      region: "Region",
      backCDashboard: "Back to company Dashboard",
      productsDischargedOn: "Products discharged on",
      totalVol: "Total Volume",
      tankStock: "Tank Stock",
      cashReport: "Cash Report",
    },

    //Company Loyalty page
    loyalty: {
      confirmDelete: "Are you sure you want to delete this program?",
      redeemType: "Redeem Type",

      startDate: "Start Date",
      endDate: "End Date",
      litresForPoint: "Litres For Point",
      title: "Set up Loyalty",
      pointVolume: "Point volume",
      literPts: " Liters for point",
      howLtrsPts: " How many litres make a point",
      ptsVal: "Point value",
      worth: "How much {currency} is a point worth",
      pointConvert:
        "How much point is redeemable (converted to wallet for purchase)",
      redeemablePoint: "Redeemable point",
      literPointErr: "please enter liters for point",
      pointValueErr: "please enter point value",
      redeemPointErr: "please enter redeemable point",
      loyaltySuccess: "Loyalty setup successfully",
      loyaltyDeleteSuccess: "Loyalty delete successfully",
      pointValue: "Point Value",
      totalPointEarnedCus: "Total points earned by customers",
      totalPendingPoints: "Total pending points",

      totalPointsRedeem: "Total redeemed points",
      currentPointBalance: "Current point balance",
      toTalPointEarned: "Total point earned",
      toTalPointRedeemed: "Total point redeemed",
    },

    //Company Expense page
    cExpense: {
      title: "Expense by categories",
      allCate: "All categories",
      totEx: "Total Expenses",
      exBreakdownFor: "Expense Breakdown for",
    },

    //Company Transaction Count page
    cTranCount: {
      title: "Transaction Count",
      between: "Transaction count from",
    },

    //Company station wallet transaction page
    cBranchWallet: {
      totalTran: "Total Transaction",
      title: "Wallet Transactions",
      between: " Retail Outlet wallet transactions between",
      date: "Date",
      station: "Station",
      creditTran: "Number of Credit Transactions",
      creditAmt: "Total Credit Amount",
      debitAmt: "Number of Debit Transactions",
      totalDebitAmt: "Total Debit Amount",
      action: "Action",
      viewMore: "View more details",
    },

    //COMPANY ASSETS
    cAsset: {
      totalAsset: "Total asset groups",
      title: "Company Asset Groups",
      desc: "You can create and manage your company asset groups here",
      createButton: "CREATE GROUP",
      grpName: " Group Name",
      description: " Description",
      grpType: "Group Type",
      numAsset: "Number of Assets",
      assetReq: "Assets Requiring Attention",
      noAssetGrp: "You currently don't have any asset group",
      createAssGrp: "Create an asset group",
      details: {
        title: "Asset for",
        desc: "Kindly select a station to view it's assetss",
        selectStation: "Select Station",
        allStation: "All Stations",
        totalAsset: "Total Assets",
        selectStatus: " Select A Status",
        allStatus: "All Status",
        okay: "Okay",
        serviceDue: "Service Due",
        renewalDue: "Renewal Due",
        notActive: "Not Active",
        renewed: "Renewed",
        enterAsset: "Enter asset #",
        assetName: "Asset Name",
        licenseNo: "License Number",
        station: "Station",
        status: "Status",
      },
    },

    //COMPANY WALLET
    cWallet: {
      title: "Company Wallet",
      balance: "Book Balance",
      ba: "Book Balance",
      date: "date",
      amount: "Amount",
      source: "Source",
      status: "Status",
      companyWalletTransaction: "Company Wallet Transactions",
    },

    //Company Send station report
    cBranchReport: {
      title: "Company Branches report",
      description: "	You can send and forward your branches reports here...",
      all: "All",
      sent: "Sent",
      notSent: "Not Sent",
      totalCount: "Total Count",
      sendReport: "Send company report",
      station: "Station",
      company: "Company",
      address: "Address",
      region: "Region",
      state: "State",
      action: "Action",
    },

    //COMPANY SERVICES
    cServices: {
      title: "Manage Services",
      description: " Manage your  services for",
      addService: "Add Service",
      viewTransactions: "View Transactions",
      totalService: "Total Services",
      serviceName: "Service name",
      action: "Action",
      totalSoldPrice: "Total sold price",
      customer: "Customer",
      price: "Price",
      serviceDescription: "Service description",
      service: "Service",
      RecordDate: "Record date",
      totalAmount: "Total amount",
      station: "Station",
      amount: "Amount",
    },

    //COMPANY BRANCH LEASE
    cBranchLease: {
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
      title: "Station Rents",
      title1: "Rents for",
      description: "   View all station rents by selecting a station here...",
      desc: "View all rents here...",
      allLeases: "All Rents",
      allLR: "All Rents",
      date: "Rent date",
      branchSpace: "Station space",
      leaseBy: "Rent by",
      occupant: "Occupant name",
      occupantEmail: "Occupant email",
      payment: "Payment completed",
      propertyName: "Property Name",
      propertyDescription: "Property Description",
      rentFee: "Rent fee",
      rooms: "Number of rooms",
      restRoom: " Number of rest rooms",
      addtional: "Addtional details",
      rentDuration: "Rent duration",
      branchSpaceTitle: "Manage station space",
      branchSpaceDesc:
        "Manage your station space here for your branches here...",
      createSpace: "Create station space",
      room: "Rooms",
      available: "Available",
      action: "Action",
      selectBranch: "Select Branch",
    },

    //COMPANY BRANCHES RETAIL OUTLET
    cOurBranches: {
      title: "Manage Retail Outlets",
      description: "You can view and manage all your retail outlets here...",
      totalOutlet: "Total Oulets",
      setupBudget: {
        title: "Setup monthly expense budget for",
        expense: "Expense budget for the month",
        button: "Set up budget",
        successMsg: "Budget setup successfully",
        errorMsg: "Please input a budget",
      },
      mapGroup: {
        title: "Map Site to Group",
        title2: "Map Station to Group",
        selectIndustryGroup: " Select Industry Group",
        selectCompanyGroup: "Select Company Group",
        mapSite: "Map site",
        mapBranch: "Map Branch",
        noGroup: "There is no group created by this company",
        toastError1: "Group Not Selected",
        toastSuccess: " Successfully Mapped Station To Group",
      },
    },

    //COMPANY DEALERS PAGE
    cDealers: {
      totalDealer: "Total Dealers",
      mapButton: "Map to new dealer",
    },

    //COMPANY GROUP MANAGEMENT PAGE
    cGrpMgt: {
      title: "Group Management",
      desc: "Create and manage your company groups here",
      createButton: "Create New",
      totalGrps: "Total Groups",
      description: "Description",
      category: "Category",
      email: "Email",
      action: "Action",
      name: "Name",
      successMsg: "Group Deletes",
    },

    //COMPANY REGION PAGE
    cRegion: {
      totalRegion: "Total Regions",
      region: "Region",
    },

    //Company sufficiency metric page
    cSufficiency: {
      title: "Sufficiency",
      projectionRate: " Tank Projection Rate",
      selectOption: "Select Increase or Decrease",
      increase: "Increase",
      decrease: "Decrease",
      inputPer: "Input Percentage",
      button: "Submit",
      volumeProjection: "Next 2 days volume projection",
      salesProjection: "Next 2 days Sales projection",
    },

    //Company Users
    cUsers: {
      title: "Manage Users",
      description: " Manage your users and their roles here...",
      createButton: "Create Users",
      addExistingUser: "Add existing user",
      users: "Users",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      status: "Status",
      accessLevel: "Access Level",
      mapSuccess: "has been unmapped successfully",
      confirmMsg: "Are you sure you want to remove this user ?",
      subTitle: "Add roles to user",
      subTitle: "Add roles to user",
      selectGrp: "Select group",
      availableRoles: " Available roles",
      createUser: {
        title1: "Add User",
        title2: "Add Roles",
        phone: "Phone Number",
        selectAccess: "Select Access Level",
        select: "Select",
        successMsg: "Successfully created user",
        categoryError: "Please select a category to continue",
        search: "Search...",
      },
      addUserToRole: {
        selectRole: "Select Role",
        companyAdmin: "Company Admin",
        branchManager: "Station Manager",
        station: "Stations",
        selectStation: " Select Station",
        roleError: "Please select a role",
        stationError: "Please select a station",
        mapSuccess: "Successfully added user to role",
      },
      userDetails: {
        title: "Edit user",
        active: "Active",
        deactivate: "Deactivated",
        suspend: "Suspended",
        forcePassword: "Force password change",
        selectAll: "Select All Roles",
      },
    },

    // Compny cashflow report
    cashflow: {
      title: "Cash Flow",
      showAll: "Show all",
      selectStation: "Select Station",
      reportBetween: " Cash flow between ",
      date: "Date",
      station: "Station",
      region: "Region",
      state: "State",
      total: "Total Sales {currency}",
      posSales: "POS Sales {currency}",
      retainerSales: "Retainer Sales {currency}",
      epumpSales: "Epump Sales {currency}",
      bankedCash: "Banked Cash {currency}",
      expense: "Expense {currency}",
      previousBalance: "Previous Balance {currency}",
      outstandingCash: "Outstanding Cash {currency}",
      vaultLimit: "Cash Vault Limit {currency}",
      compliance: "Compliance(%)",
    },

    //Company Aggregated Faults
    cAggregated: {
      title: "Aggregated Faults",
      desc: " View your aggregated company faults here...",
      totalFault: "Total faults",
      station: "Station",
      name: "Name",
      recordedBy: "Recorded By",
      type: "Type",
    },

    //COMPANY MAINTENANCE PAGE
    cMaintenance: {
      title: "Maintenance List",
      desc: "View your company maintenance list here...",
      totalMain: "Total Maintenance",
    },
    cWaybill: {
      title: "Waybill List",
      desc: "View your company waybill list here...",
      createWaybill: "CREATE WAYBILL",
      totalWaybill: "Total Waybill",
      date: "Date",
      refNo: "Reference Number",
      product: "Product",
      vol: "Volume",
      comment: "Comment",
      // New
      waybillDetailsFor: "Waybill Details for",
      delWaybill: "Delete Waybill?",
      delatedWaybill: "waybill deleted",
      askMark: "Mark as used?",
      markUsed: "Mark as Used",
      used: "Used",
      waybillMarked: "waybill marked",
    },

    cTrucks: {
      title: "Truck And Driver List",
      desc: "View your company truck and driver list here...",
      addTruck: "ADD TRUCK",
      addDriver: "ADD DRIVER",
      totalTruck: "Total Trucks",
      totalDriver: "Total Drivers",
      totalAssigned: "Total Assigned",
      allTruck: "ALL TRUCKS",
      allDrivers: "ALL DRIVERS",
      assignedTrucks: " ALL TRUCKS ASSIGNED TO DRIVERS",
      fullname: "Fullname",
      phoneNo: "Phone Number",
      tankType: "Tank Type",
      email: "Email",
      driver: "Driver",
    },

    //COMPANY ALERT PAGE
    cAlerts: {
      title: "ALERTS AND ALARM",
      desc: " Create and manage your alerts and alarms here",
      createButton: "CREATE NEW",
      totalAlert: " Total ALERT/ALARM",
      owner: "Owner",
      event: "Event",
      deleteQuest: "Delete Alert/Alarm?",
      deletedAA: "Alert/Alarm Deleted",
    },

    //Company Wallet
    cWallet: {
      title: "Wallet",
      description: "   View your wallet transactions here...",
      fundButton: "FUND WALLET",
      walletBalance: "Wallet Balance",
      date: "Date",
      amount: "Amount",
      source: "Source",
      status: "Status",
      desc: "Description",
    },

    cShutdown: {
      pumpShut: "Pump shutdown",
      shutdownHistory: "Shutdown History",
      shutdownPump: "Shutdown pumps",
      action: "Action",
    },

    //Company Invoice
    cInvoice: {
      title: "Invoices",
      overdue: "Overdue",
      last: "Last",
      due: "Due within next 30 days",
      allStatus: "All status",
      paid: "Paid",
      partPaid: "Part Paid",
      allInvoice: "All Invoice",
      status: "Status",
      du: "Due",
      date: "Date",
      customer: "Customer",
      amountDue: "Amount Due",
      fuelMetrics: "Fuelmetrics",
      nigeria: "Nigeria",
      station: "Station",
      setupPayment: "Setup payment",
      settleInvoice: "Settle Invoice",
      details: {
        makePayment: "Make Payment",
        invoicePayment: "Invoice Payments",
        exportPDF: "Export PDF",
        billTo: "Bill to",
        invoiceNum: "Invoice number",
        invoiceDate: "Invoice date",
        paymentDue: "Payment due",
        items: "Items",
        quantity: "Quantity",
        price: "Price",
        amount: "Amount",
        noItem: "You have not added any items.",
        subTotal: "Sub Total",
        total: "Total",
        amountPaid: "Amount Paid",
        edit: "Edited",
      },
      payment: {
        totalAmount: "Total Amount Paid",
        payments: "Payments",
        method: "Payment Method",
        note: "Note",
        action: "Action",
      },
      breakdown: {
        title: "monthly payment breakdown by stations",
        desc1: "payment is now easier with recurring payment,",
        desc2:
          "   we automatically deduct the monthly subsription from the account provided",
        totalAmount: "Total amount",
        monthly: "Monthly",
        subList: " List of company subscriptions breakdown",
      },
      setRecurring: {
        title: "monthly invoice",
        edited: "Edited",
      },
      sub: {
        title: "subscription transactions by stations",
        desc: "   you can manage your subscription transactions here :)",
      },
      subTran: {
        title: "subscription transactions",
        desc2: "you can manage your subscription transactions here :)",
      },
      success: {
        success: "Sucess",
        error1: "Something went wrong",
        error2: "We are unable to set up your payment successfully",
        continue: "Continue to subscriptions",
      },
    },

    //Company Bank page
    cBank: {
      confirmSettlement: "Confirm Settlement",
      paymentConfirmed: "Payment Confirmed",
      makeRequest: "Make Request",
      amountToSettle: "Amount to settle",
      confirm: "Confirm",
      confirmSettlement: "Confirm Settlement",
      transactionType: "Transaction type",
      makeBankRequestTitle: "Make Bank Request",
      bankAcctRequestDesc: "View bank account requests here...",
      confirmMsg: "Are you sure you want to remove this account?",
      removedSuccess: "Successfully removed account",
      date: "Date",
      transactionRef: "Transaction reference",
      station: "Station",
      status: "Status",
      summary: "Summary",
      bank: "Bank",
      accountName: "Account Name",
      catRemove: "Can't remove",
      accountNumber: "Account Number",
      linked: "Linked",
      linkedService: "Linked Service",
      credit: "Credit",
      debit: "Debit",
      selectStation: "Select station",
      showAll: "Show All",
      selectStatus: "Select status",
      approve: "Approved",
      declined: "Declined",
      totalTransactions: "Total Transactions",
      successTrans: "Successful Transactions",
      failedTrans: "Failed Transactions",
      cashBack: "Total Cashback Charges",
      amount: "Amount",
      hi: "Hi",
      action: "Action",
      account: {
        title: "Bank accounts",
        description: "Link your bank accounts to reconcile bank deposits",
        desc1: "pay monthly subscription, etc.",
        addBank: "Add new bank",
        accountList: "  List of bank accounts",
        iconInfo:
          "This icon indicates linked bank accounts, this means we confirm your deposit to the account. You can have multiple linked accounts",
        removeBank: "Remove bank",
        accountsAdded: " Accounts added will show up here",
        noBankLinked: "You currently don't have any bank linked",
        accountDisplayed: "Bank accounts will be displayed when added",
      },
      bankLinked: {
        title: "Bank deposits",
        amountPaid: "Amount Paid",
        amountRaised: "Amount Raised",
        difference: "Difference",
        accountDisplayed:
          "Bank linked transactions will be displayed when added",
      },
      transaction: {
        title: "Bank transactions",
        title1: "Bank transactions breakdown",
        description: " View your bank transactions here...",
        totalCredit: "Total Credit",
        totalDebit: "Total Debit",
        balance: "Balance",
        totalBalance: "Total Balance",
        previous: "Previous",
        currentPage: "Current Page",
        next: "Next",
        noTransaction: "You currently don't have any live bank transactions",
        accountDisplayed: "live bank transactions will be displayed when added",
      },
      posTerminal: {
        description:
          "You can assign and re-assign POS to a selected stations here :)",
        between: " POS transactions between",
        transactionDate: "Transaction Date",
        pump: "Pump",
        maskedPan: "Masked Pan",
      },
      terminal2: {
        title: "You can assign and re-assign POS to a selected station here :)",
        allTerminals: "All Terminals",
        id: "Terminal Id",
        serialNum: "Serial Number",
        vendor: "Vendor",
        noTerminal: "There is currently no terminal created",
      },
      bExpenses: {
        title: "Station Expenses",
        desc: "You can filter data based on a selected station and region here.",
        selectRegion: "Select region",
        allRegions: "All regions",
        selectBranch: "Select branch",
        allBranches: "All Branches",
        totalBranches: "Total Branches",
        expense: "Expense(NGN)",
      },
    },

    //COMPANY DRYSTOCK
    cDrystock: {
      edit: "Edit",
      add: "Add",
      stock: "stock",
      product: {
        title: "Manage Products",
        description: " Manage your  products here...",
        createProduct: "Create Product",
        totalProduct: "Total Product",
        name: "Name",
        desc: "Description",
        qtnUnit: "Quantity per unit",
        category: "Product Category",
        cate: "Category",
        selectCate: "select category",
        action: "Action",
        qtn: "Quantity",
        createHeader: "Non wet product",
      },
      productStock: {
        description: " View stock details for",
      },
      supplies: {
        title: "Manage dry stock supplies",
        description: " Manage your supplies here...",
        addSupply: "Add Supply",
        totalSupply: "Total supplies",
        totalCost: "Total Cost",
        qtnSupplied: "Quantity supplied",
        date: "Date",
        station: "Station",
        status: "Status",
        action: "Action",
        supply: "Supply",
        selectProd: "Select product",
        unitPrice: "Unit price",
        removeItem: "Remove item",
        selectStation: "Select Station",
        enterDiscountAmount: "Enter discount amount",
        discountAmount: "Discount amount",
        totalQtn: "Total quantity",
        totalPrice: "Total price",
        supplyAccepted: "Supply accepted",
        supplyCompleted: "Supply completed",
        noSupply: "  You currently don't have any supply added",
        noSupplyDesc: "Supplies will be added here when added",
        history: {
          title: "Supplies history for",
          description: "  View your dry stock supplies history here....",
        },
        details: {
          title: "Dry stock supply details",
          description: " View your dry stock supply details here...",
        },
      },
      sales: {
        table: "Table",
        chart: "Chart",
        companySales: "Company Sales",
        salesReport: "Company Sales Report Between",
        branch: "Branch",
        date: "Date",
        dateOfSales: "Date of sales",
        branchName: "Station Name",
        stationName: "Station Name",
        tankName: "Tank Name",
        product: "Product",
        action: "Action",
        productCategory: "Product category",
        vol: "Vol (ltr)",
        amount: "Amt {currency}",
        total: "Total {currency}",
        totalSales: "Total sales",
        posSales: "POS sales",
        retainerSales: "Retainer sales",
        epumpSales: "Epump  sales",
        expense: "Expense",
        prevBal: "Previous Balance",
        previousBal: "Previous Balance",
        outstandingCash: "Outstanding cash",
        cshFlow: "Cash Flow",
        compliance: "Compliance",
        selectBranch: "Select branch",
        cashVaultLimit: "Cash vault limit",
        bankedCash: "Banked cash",
        totalVolumeSold: "Total Number of Volume sold by stations",
        totalSoldPrice: "Total sold price",
        totalQuantitySold: "Total Quantity sold",
        quantitySupplied: "Quantity Supplied",
        totalSupplies: "Total supplies",
        total: "Total cost",
        totalPrice: "Total price",
        totalVolumeForDealers: "Total Volumes of Products sold by Dealers",
        dealerSalesSummary: "Dealer Sales Summary",
        groupSalesSummary: "Group sales Summary",
        salesHistoryFor: "Sales History For",
        branchSales: "Station sales",
        stationSales: "Station sales",
        state: "State",
        cashFlow: "Cash Flow Between",
        totalCost: "Total cost",
        and: "and",
        regionSales: "Region Sales",
        status: "Status",
        unitPrice: "Unit price",
        region: "Region",
        pmsPumpSale: "PMS Pump Sale",
        pmsVolume: "PMS Volume",
        agoVolume: "Ago Volume",
        dpkVolume: "DPK Volume",
        lpgVolume: "LPG Volume",
        pmsTankSale: "PMS Tank Sale",
        pmsSurplus: "PMS Surplus",
        agoPumpSale: "Ago Pump Sale",
        agoTankSale: "Ago Tank Sale",
        agoSurplus: "Ago Surplus",
        dpkPumpSale: "DPK Pump Sale",
        dpkTankSale: "DPK Tank Sale",
        dpkSurplus: "DPK Surplus",
        quantitySold: "Quantity Sold",
        productSaleBreakdown: "Product sale breakdown for",
        on: "on",
        suppliesHistoryFor: "Supplies history for",
        saleDetailsFor: "Sale details for",
        dryStockSale: "View your dry stock sales breakdown here...",
        dryStockDetails: "View your dry stock sale details here...",
        dryStockHistory: "View your dry stock sale history here...",
        dryStockSupplyDetail: "View your dry stock supply details here...",
        supplyAccepted: "Supply accepted",
        supplyCompleted: "Supply completed",
        manageDryStock: "Manage dry stock supplies",
        manageDryStockSales: "Manage dry stock sales",
        dryStockSupply: "Dry stock supply details",
        dryStockSupplies: "Manage your dry stock supplies here",
        tankSales: "Tank sales",
        volFilled: "Volume Filled(Ltrs)",
        volSold: "Volume sold(Ltrs)",
        tankStock: "Tank Stock",
        ltrs: "Ltrs",
        pms: "PMS",
        nA: "N/A",
        ago: "AGO",
        dpk: "DPK",
        lpg: "LPG",
        tankVariance: "Tank Variance",
        title: "Product sales",
        description: "  Manage your dry stock sales here...",
        totalSales: "Total Sales",
        totalSoldPrice: "Total sold price",
        totalQtnSold: "Total Quantity Sold",
        date: "Date",
        station: "Station",
        discount: "Discount price",
        qtnSold: "Quantity sold",
        totalPrice: "Total price {currency}",
        action: "Action",
        breakDown: {
          title: "Product sales breakdown for",
          desc: " view your dry stock sales breakdown here... ",
          customer: "Customer",
        },
        details: {
          title: "Sale details for ",
          desc: "view your dry stock sale details here...",
        },
        history: {
          title: "Sales History for ",
          desc: "View your dry stock sales history here...",
        },
      },
      // sales: {},
      branchStock: {
        title: "Station products stock",
        description:
          "    select a station to see the corresponding products stock for that here",
        selectBranch: "Select branch",
        totalStock: "Total stock",
        station: "Station",
        totalQtnSupplied: "Total quantity supplied",
        totalQtnSold: "Total Quantity Sold",
        product: "Product name",
        qtnSupplied: "Quantity supplied",
        qtnRemaining: "Quantity remaining",
        qtnSold: "Quantity sold",
        action: "Action",
      },

      categories: {
        title: "Dry stock  product categories",
        description: " Manage your  dry stock product categories here...",
        createCate: "Create category",
        totalCate: "Total category",
        name: "Name",
        desc: "Description",
        action: "Action",
        add: "Add",
        save: "Save",
        successfullyCreated: "Category created successfully",
        successfullyUpdated: "Category updated successfully",
      },
    },

    //company partners
    cPartners: {
      managePartners: "Manage acquiring partners",
      managePartnersHere: "Manage your  acquiring partners here...",
      addPartner: "Add partner",
      totalPartners: "Total partners",
    },

    //COMPANY SALES SUMMARY
    cSalesSummary: {
      title: "Company Sales Summary",
      state: "State",
      date: "Date",
      region: "Region",
      pmsPump: "PMS Pump Sale",
      pmsTank: "PMS Tank Sale",
      pmsSurplus: "PMS Surplus",
      agoPump: "AGO Pump Sale",
      agoTank: "AGO Tank Sale",
      agoSurplus: "AGO Surplus",
      dpkPump: "DPK Pump Sale",
      dpkTank: "DPK Tank Sale",
      dpkSurplus: "DPK Surplus",
      branch: "Branch",
      station: "Station",
    },

    //COMPANY STOCK VALUATION
    cStockValuation: {
      title: " Stock valuation",
      noStock: "No stocks valuation recorded",
      curVol: "Current Volume",
      valuation: "Valuation",
    },

    //COMPANY DAILY BRANCH TRANSACTION
    cBranchTransaction: {
      title: "Daily station transactions",
      description: " You can view daily station transactions here... ",
      reportBetween: "   Daily station transactions on",
      state: "State",
      region: "Region",
      product: "Product",
      transactionCount: "Transaction Count",
      station: "Station",
    },

    // Company disconnected pumps
    cDisconnectedPumps: {
      title: "Disconnected Pumps",
      deviceId: "Device Id",
      pump: "Pump",
      branchName: "Station Name",
      date: "Date",
      disconnectedHistory: "Disconnected History",
      startTime: "Start Time",
      disconnectionHistory: "Disconnection History",
      endTime: "End Time",
      salesReport: "Sales Report",
      na: "N/A",
      ltrs: "Ltrs",
      kg: "Kg",
    },
    // Company offline pumps
    cOfflinePumps: {
      title: "Offline Pumps",
      deviceId: "Device Id",
      nozzles: "Nozzles (If Pump)",
      branchName: "Station Name",
      lastDate: "Last Date",
    },
    // Our Dealers
    dealers: {
      title: "Our Dealers",
      details: "Details",
      branches: "Stations",
      searchDealers: "Search Dealers",
      selectDate: "select start date & time",
      selectEndDate: "select end date & time",
    },
    // Dealer Details
    dealerDetails: {
      title: "Dealer Details",
      street: "Street",
      city: "City",
      state: "State",
      goBack: "Go Back To Dealers",
      street: "Street",
      city: "City",
      state: "State",
    },

    // Driver
    // Assign Truck
    assignTruck: {
      title: "Trucks",
      assignTruck: "Assign Truck",
      truckName: "Truck Name",
      plateNumber: "Plate Number",
      tankType: "Tank Type",
      capacity: "Capacity",
      successfullyAssignedTruck: "Successfully Assigned Truck",
      failedToAssign: "Failed To Assign Truck",
      assignToDriver: "Assign To Driver",
      assignToTruck: "Assign To Truck",
    },
    // Assigned Orders
    assignedOrders: {
      title: "Assigned Orders",
      companyName: "Company Name",
      contactName: "Contact Name",
      contactPhone: "Contact Phone",
      driverName: "Driver Name",
      state: "State",
      quantity: "Quantity",
      status: "Status",
      product: "Product",
      successfullyAssignedTruck: "Successfully Assigned Truck",
      failedToAssign: "Failed To Assign Truck",
    },
    // Assigned Truck
    assignedTruck: {
      title: "Assigned Truck | Assigned Trucks",
      truckName: "Truck Name",
      plateNumber: "Plate Number",
      tankType: "Tank Type",
      capacity: "Capacity",
    },
    // Customer Location
    customerLocation: {
      totLoc: "Total Locations",
      locations: "Locations",
      desc: "You can view all your company",
      desc1: "locations here",
      locationName: "Location name",
      longitude: "Longitude",
      latitude: "Latitude",
    },
    // Manage Drivers
    manageDrivers: {
      title: "Company Driver | Company Drivers",
      addDriver: "ADD DRIVER",
      fullName: "Full Name",
      email: "Email",
      phoneNo: "Phone No.",
      assignedOrders: "Assigned Orders",
      assignTruck: "Assign Truck",
      assignedTrucks: "Assigned Trucks",
      successfullyDeletedDriver: "Successfully deleted driver",
      failedToDelete: "Failed To Delete Driver",
      confirmDelete: "Are you sure you want to delete this driver?",
    },
    // Manage Trucks
    manageTrucks: {
      title: "Company Truck | Company Trucks",
      addTruck: "ADD TRUCK",
      truckName: "Truck Name",
      plateNumber: "Plate Number",
      tankType: "Tank Type",
      capacity: "Capacity",
      successfullyDeletedTruck: "Successfully deleted Truck",
      failedToDelete: "Failed To Delete Truck",
      confirmDelete: "Are you sure you want to delete this truck?",
    },

    // Fund Wallet Request
    fundWalletRequest: {
      title: "Wallet Fund Request",
      showAll: "Show All",
      approved: "Approved",
      pending: "Pending",
      depositorsName: "Depositor's Name",
      amountPaid: "Amount Paid",
      bankName: "Bank name",
      depositSlipNo: "Deposit Slip No.",
      datePaid: "Date Paid",
      requestDate: "Request Date",
      walletCredited: "Wallet Credited",
      approveRequest: "Approve Request",
      successfullyApproved: "Successfully Approved Fund Request",
    },
    // Branch

    // Mail Recipient
    mailRecipient: {
      title: "Mail Recipients",
      addRecipient: "Add Recipient To Station",
      add: "Add",
      emailPlaceholder: "Email *",
      phonePlaceholder: "Phone",
      email: "Email",
      phone: "Phone Number",
      successfullyRemoved: "Successfully removed Mail Recipient",
      successfullyAdded: "Successfully Added Mail Recipient",
      confirmDelete: "Are you sure you want to delete this recipient?",
    },
    // Targets
    targets: {
      title: "Targets",
      branchTargets: "Retail Outlet Targets",
      createTarget: "Create Target",
      product: "Product",
      quantity: "Quantity",
      emptyTarget: "You currently don't have any target record",
      editTarget: "Edit Target",
      deleteTarget: "Delete Target",
      confirmDelete: "Are you sure you want to delete this target?",
      successfullyDeleted: "Target deleted successfully",
      targetNotFound:
        "We couldn't find an existing Product Target to be removed, or it has already been removed",
      unsuccessfulDelete: "Failed to delete target",
    },
    // Manage Expenses Section
    // Bank Accounts
    bankAccounts: {
      noOfBankAccounts: "Number of Bank Accounts",
      bankName: "Bank Name",
      selectBankName: "Select a Bank Name",
      accountNumber: "Account Number",
      inputAccountNumber: "Account Number",
      accountName: "Account Name",
      inputAccountName: "Account Name",
      save: "Save",
      name: "Name",
      accountNo: "Account No.",
      delete: "Delete",
      emptyBankRecord: "You currently don't have any Bank Account record",
      selectBankError: "Please select a bank",
      bankAdded: "Bank Account successfully added",
      confirmDelete: "Are you sure you want to delete this account?",
      successfullyDeleted: "Bank Account successfully deleted",
      unsuccessfulDelete: "Unable to delete bank account",
      linkedAccounts:
        "This icon indicates linked bank accounts,this means we confirm",
      multipleLinkedAccounts:
        "your deposit to the account. You can have multiple linked accounts",
      accountsShow: "Accounts added will show up here",
      bankDeposits: "Bank deposits",
      amountPaid: "Amount paid",
      amountRaised: "Amount raised",
      difference: "Difference",
      noLinkedTransaction:
        "You currently don't have any bank linked transactions ",
      bankTransDisplay: "Bank linked transactions will be displayed when added",
      dateCreated: "Date created",
      dateLinked: "Date Linked",
      transactionReference: "Transaction reference",
      station: "Station",
      summary: "Summary",
      bank: "Bank",
      linked: "Linked",
      linkedService: "Linked service",
      status: "Status",
      bankTrans: "Bank transactions",
      viewBankTrans: "View your bank transactions here...",
      totalCredit: "Total Credit:",
      totalDebit: "Total Debit:",
      balance: "Balance:",
      bal: "Balance",
      noLiveTrans: "You currently don't have any live bank transactions",
      displayLiveTrans: "live bank transactions will be displayed when added",
      action: "Action",
      debit: "Debit",
      credit: "Credit",
      bankTransBreakdown: "Bank transactions breakdown",
      date: "Date",
      amount: "Amount",
      type: "Type",
      narration: "Narration",
    },
    // Categories
    categories: {
      title: "Categories",
      createCategory: "Create Category",
      inputCategoryPlaceholder: "Input Category",
      create: "Create",
      category: "Category",
      dateCreated: "Date Created",
      confirmDelete: "Are you sure you want to delete this category?",
      successfullyDeleted: "Successfully deleted category",
      unsuccessfulDelete: "Failed to delete category",
      successfullyAdded: "Successfully added category",
      inputCategory: "Please input a category",
      dryStock: "Dry stock product categories here...",
      manageDryStock: "Manage your dry stock product categories here...",
      totalCategories: "Total categories",
      name: "Name",
      customer: "Customer",
      desc: "Description",
      quantity: "Quantity",
      action: "Action",
      selectBranch: "Select branch",
      unitPrice: "Unit price",
      nonWetProduct: "Non wet product",
      categories: "Categories",
      selectCategory: "select category",
      quantityPerUnit: "Quantity per unit",
      quantitySupplied: "Quantity supplied",
      addSupply: "Add supply",
      enterDiscount: "Enter discount amount",
      totalQuantity: "Total quantity:",
      totalPrice: "Total price:",
      submitSupplies: "Submit supplies",
      noSuppliesAdded: "You currently don't have any supply added",
      supplyAdded: "Supplies will be added here when added",
      stock: "Stock",
      viewStock: "view stock details for",
      here: "here",
      totalStock: "Total Stock",
      totalQuantitySupplied: "Total quantity supplied",
      totalQuantitySold: "Total quantity sold",
      productName: "Product name",
      productCategory: "Product Category",
      branch: "Branch",
      station: "Station",
      discountPrice: "Discount price",
      quantitySold: "Quantity sold",
      quantityRemaining: "Quantity remaining",
      dateOfSales: "Date of sales",
      service: "Service",
      addTransaction: "Add transaction",
      trans: "transaction",
      totalPrice: "Total price",
      totalPrc: "Total price ",
      customerName: "Enter customer name",
      selectBranch: "Select branch",
      submit: "Submit",
      noTransAdded: "You currently don't have any transaction added",
      transAdded: "transactions will be added here when added",
    },
    // Manage Expenses
    manageExpenses: {
      totalExpenses: "Number Of Expenses",
      title: "Manage Expenses",
      companyExpensesBetween: "Company Expenses Between",
      expensesBreakdown: "Expenses Breakdown",
      income: "Income",
      expenses: "Expenses",
      retailOutlets: "Retail Outlets",
      amount: "Amount",
      account: "Account",
      successfullyDeleted: "Successfully deleted category",
      unsuccessfulDelete: "Failed To Delete Category",
      confirmDelete: "Are you sure you want to delete this category?",
      branchExpenses: "Branches Expenses",
      filterData:
        "You can filter data based on a selected station and region here.",
      selectRegion: "Select region",
      allRegions: "All regions",
      selectBranch: "Select branch",
      allBranches: "All Branches",
      totalBranches: "Total branches",
      branch: "Branch",
      station: "Station",
      region: "Region",
      expense: "Expense(NGN)",
      expenseCategory: "Expense by categories",
      allCategories: "All categories",
      totalExpense: "Total Expense",
      expenseBreakdown: "Expense breakdown for",
      date: "Date",
      retailOutlets: "Retail outlets",
      description: "Description",
      category: "Category",
    },
    // Orders Section
    // Add Order
    addOrder: {
      title: "Create Order",
      orderInformation: "Order Information",
      quantity: "Quantity",
      contactName: "Contact Name",
      paymentMode: "Payment Mode",
      cash: "Cash",
      cheque: "Cheque",
      transfer: "Transfer",
      paid: "Paid",
      true: "True",
      false: "False",
      deliveryHours: "Delivery Hours",
      product: "Product",
      selectAProduct: "Select a product",
      contactInformation: "Contact Information",
      street: "Street",
      city: "City",
      state: "State",
      contactPhone: "Contact Phone",
      phonePlaceholder: "Phone No.",
      productMissing: "Please select a product",
      quantityMissing: "Please input a quantity",
      deliveryHoursMissing: "Please input a delivery hour",
      successfullyCreated: "Successfully created order",
      unsuccessfullyCreated: "Failed to add order",
    },
    // Assign Driver
    assignDriver: {
      drivers: "Drivers",
      title: "Assign Driver",
      fullName: "Full Name",
      email: "Email",
      phoneNo: "Phone No.",
      successfullyAssigned: "Successfully assigned driver",
      unsuccessfullyAssigned: "Failed to assign driver",
    },
    // Edit Order
    editOrder: {
      title: "Edit Order",
      orderInformation: "Order Information",
      quantity: "Quantity",
      contactName: "Contact Name",
      status: "Status",
      driverAssigned: "Driver Assigned",
      paymentPending: "Payment Pending",
      paymentCompleted: "Payment Completed",
      paymentConfirmed: "Payment Confirmed",
      orderCompleted: "Order Completed",
      orderAccepted: "Order Accepted",
      orderRejected: "Order Rejected",
      processing: "Processing",
      inTransit: "In Transit",
      arrived: "Arrived",
      ownerAccepted: "Owner Accepted",
      fillStarted: "Fill Started",
      fillEnded: "Fill Ended",
      product: "Product",
      selectAStatus: "Select A Status",
      selectAProduct: "Select A Product",
      contactInformation: "Contact Information",
      street: "Street",
      city: "City",
      state: "State",
      contactPhone: "Contact Phone",
      phonePlaceholder: "Phone No.",
      updateOrder: "Update Order",
      quantityMissing: "Please input a quantity",
      deliveryHoursMissing: "Please input a delivery hour",
      successfullyUpdated: "Successfully updated order",
    },
    // Manage Orders
    manageOrders: {
      title: "Orders",
      showAll: "Show All",
      driverAssigned: "Driver Assigned",
      paymentPending: "Payment Pending",
      paymentCompleted: "Payment Completed",
      paymentConfirmed: "Payment Confirmed",
      orderCompleted: "Order Completed",
      orderAccepted: "Order Accepted",
      orderRejected: "Order Rejected",
      processing: "Processing",
      inTransit: "In Transit",
      arrived: "Arrived",
      ownerAccepted: "Owner Accepted",
      fillStarted: "Fill Started",
      fillEnded: "Fill Ended",
      orderStatusFilter: "Order Status Filter",
      contactName: "Contact Name",
      contactPhone: "Contact Phone",
      status: "Status",
      quantity: "Quantity",
      city: "City",
      state: "State",
      assignDriver: "Assign Driver",
      editOrder: "Edit Order",
      updateStatus: "Update Status",
      confirmDelete: "Are you sure you want to delete this order?",
      successfullyDeleted: "Successfully deleted order",
      unsuccessfulDelete: "Failed to delete order",
    },
    // Company Price Management
    priceManagement: {
      title: "Change Price",
      priceChangeLog: "Price Change Log",
      companyPriceUpdate: "Company Price Update",
      selectZone: "SELECT REGION | select region",

      selectState: "SELECT STATE | select state",
      selectProduct: "SELECT PRODUCT",
      newPrice: "NEW PRICE | New price",
      retailOutlets: "Retail Outlets",
      searchRetailOutlets: "Search Retail Outlets",
      selectAllRetailOutlets: "Select All Retail Outlets",
      updateNow: "Update Now",
      scheduleUpdate: "Schedule Update",
      recentlyUpdated: "Recently Updated",
      formerPrice: "Former Price",
      updatedPrice: "Updated Price",
      viewMore: "View More",
      branchName: "Station Name",
      product: "Product",
      currentPrice: "Current Price",
      previousPrice: "Previous Price",
      changedBy: "Changed By",
      date: "Date",
      password: "Password",
      cancel: "Cancel",
      submit: "Submit",
      selectProductSmall: "Select Product",
      selectBranch: "Please select at least one retail outlet",
      successfullyChanged: "Successfully changed price",
      putPassword: "Please input your password",
      putToken: "Please input your token",
      sendingToken: "Wait, we are sending token to",
      tokenExpired: "Token expired, click here to resend",
      tokenExpire: "Token have been sent to",
      tokenExpire2: "and will expire in",
      token: "Token",
      branchPriceUpdate: "Station Price Update",
    },
    // Product
    // Add Product
    addProduct: {
      title: "Add Product",
      productInformation: "Product Information",
      product: "Product",
      selectAProduct: "Select A Product",
      price: "Price",
      state: "State",
      localGovArea: "Local Government Area",
      localGov: "Local Government",
      deliveryHour: "Delivery Hour",
      addMore: "Add More",
      addProduct: "Add Product",
      selectLGA: "Please select an LGA",
      deliveryHourMissing: "Please input a delivery hour",
      successfullyAdded: "Successfully added product",
      invalidDeliveryHour: "Please input a valid delivery hour",
    },
    // Products
    deliverableProducts: {
      totalDeliverableProd:
        "Total Deliverable Product | Total Deliverable Products",
      addProduct: "Add Product",
      productName: "Product Name",
      price: "Price",
      state: "State",
      noOfDeliverableLGAs: "No. of deliverable LGAs",
      manageLGAs: "Manage LGAs",
      confirmDelete: "Are you sure you want to delete this product?",
      successfullyDeleted: "Successfully deleted product",
      unsuccessfulDelete: "Failed to delete product",
    },
    // Product LGAs
    productLGA: {
      title: "LGAs",
      localGovAreas: "Local Government Areas",
      lgaName: "LGA Name",
      deliveryHour: "DeliveryHour",
    },
    // Profile
    profile: {
      accountSettings: "Account Settings",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      editProfile: "Edit Profile",
      changeYourPassword: "Change Your Password",
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      changePassword: "Change Password",
      successfullyChanged: "Successfully changed Password!",
      fillIn: "Fill in the missing Fields",
      updated: "Profile updated successfully",
      passwordBlank: "Password field cannot be blank",
      passwordsDontMatch: "Passwords don't match",
      oneNumbericCharacter: "One Numberic character",
      oneSpecialCharacter: "One Special character",
    },
    // Retainerhip
    companyRetainership: {
      title: "Retainership",
      addExisting: "Add Existing",
      addNew: "Add New Retainership",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      balance: "Balance",
      creditLimit: "Credit Limit",
      walletTransactions: "Wallet Transactions",
      loyaltyPts: "Loyalty Points",
      downloadReport: "Download Report",
      generate: "Generate",
    },
    // Wallet Transactions
    walletTransactions: {
      title: "Wallet Transactions",
      transBetween: "Wallet Transactions Between",
      date: "Date",
      status: "Status",
      amount: "Amount",
      currentBalance: "Current Balance",
      description: "Description",
      newBal: "New balance",
    },
    // Company Sales Report
    sales: {
      table: "Table",
      chart: "Chart",
      companySales: "Company Sales",
      salesReport: "Company Sales Report Between",
      branch: "Branch",
      date: "Date",
      dateOfSales: "Date of sales",
      branchName: "Station Name",
      stationName: "Station Name",
      tankName: "Tank Name",
      product: "Product",
      action: "Action",
      productCategory: "Product category",
      vol: "Vol (ltr)",
      amount: "Amt {currency}",
      total: "Total {currency}",
      totalSales: "Total sales",
      posSales: "POS sales",
      retainerSales: "Retainer sales",
      epumpSales: "Epump  sales",
      expense: "Expense",
      prevBal: "Previous Balance",
      previousBal: "Previous Balance",
      outstandingCash: "Outstanding cash",
      cshFlow: "Cash Flow",
      compliance: "Compliance",
      selectBranch: "Select branch",
      cashVaultLimit: "Cash vault limit",
      bankedCash: "Banked cash",
      totalVolumeSold: "Total Number of Volume sold by stations",
      totalSoldPrice: "Total sold price",
      totalQuantitySold: "Total Quantity sold",
      quantitySupplied: "Quantity Supplied",
      totalSupplies: "Total supplies",
      total: "Total cost",
      totalPrice: "Total price",
      totalVolumeForDealers: "Total Volumes of Products sold by Dealers",
      dealerSalesSummary: "Dealer Sales Summary",
      groupSalesSummary: "Group sales Summary",
      salesHistoryFor: "Sales History For",
      branchSales: "Station sales",
      stationSales: "Station sales",
      state: "State",
      cashFlow: "Cash Flow Between",
      totalCost: "Total cost",
      and: "and",
      regionSales: "Region Sales",
      status: "Status",
      unitPrice: "Unit price",
      region: "Region",
      pmsPumpSale: "PMS Pump Sale",
      pmsVolume: "PMS Volume",
      agoVolume: "Ago Volume",
      dpkVolume: "DPK Volume",
      lpgVolume: "LPG Volume",
      pmsTankSale: "PMS Tank Sale",
      pmsSurplus: "PMS Surplus",
      agoPumpSale: "Ago Pump Sale",
      agoTankSale: "Ago Tank Sale",
      agoSurplus: "Ago Surplus",
      dpkPumpSale: "DPK Pump Sale",
      dpkTankSale: "DPK Tank Sale",
      dpkSurplus: "DPK Surplus",
      quantitySold: "Quantity Sold",
      productSaleBreakdown: "Product sale breakdown for",
      on: "on",
      suppliesHistoryFor: "Supplies history for",
      saleDetailsFor: "Sale details for",
      dryStockSale: "View your dry stock sales breakdown here...",
      dryStockDetails: "View your dry stock sale details here...",
      dryStockHistory: "View your dry stock sale history here...",
      dryStockSupplyDetail: "View your dry stock supply details here...",
      supplyAccepted: "Supply accepted",
      supplyCompleted: "Supply completed",
      manageDryStock: "Manage dry stock supplies",
      manageDryStockSales: "Manage dry stock sales",
      dryStockSupply: "Dry stock supply details",
      dryStockSupplies: "Manage your dry stock supplies here",
      tankSales: "Tank sales",
      volFilled: "Volume Filled(Ltrs)",
      volSold: "Volume sold(Ltrs)",
      tankStock: "Tank Stock",
      ltrs: "Ltrs",
      pms: "PMS",
      nA: "N/A",
      ago: "AGO",
      dpk: "DPK",
      lpg: "LPG",
      tankVariance: "Tank Variance",
      title: "Product sales",
      description: "  Manage your dry stock sales here...",
      totalSales: "Total Sales",
      totalSoldPrice: "Total sold price",
      totalQtnSold: "Total Quantity Sold",
      date: "Date",
      station: "Station",
      discount: "Discount price",
      qtnSold: "Quantity sold",
      totalPrice: "Total price {currency}",
      action: "Action",
      breakDown: {
        title: "Product sales breakdown for",
        desc: " view your dry stock sales breakdown here... ",
        customer: "Customer",
      },
      details: {
        title: "Sale details for ",
        desc: "view your dry stock sale details here...",
      },
      history: {
        title: "Sales History for ",
        desc: "View your dry stock sales history here...",
      },
    },
    // Company Tanks Filled Report
    tanksFilledReport: {
      title: "Product Discharged",
      tanksFilledOn: "Product Discharged On",
      branchName: "Station Name",
      tankName: "Tank name",
      eVolumeDischarged: "Epump Volume Discharged(ltr)",
      mVolumeDischarged: "Manual Volume Discharged(ltr)",
      variance: "Variance",
      eStartVolume: "Epump Start Volume(ltr)",
      eVolumeEnd: "Epump End Volume(ltr)",
      mStartVolume: "Manual Start Volume(ltr)",
      mEndVolume: "Manual End Volume(ltr)",
      startTime: "Start Time",
      endTime: "End Time",
      plateNumber: "Plate Number",
      noTanksFilledOn: "No Product Discharged  On",
    },
    // Company Variance Report
    varianceReport: {
      totalTransactions: "Total Transactions",
      showAll: "Show All",
      productFilter: "Product Filter",
      title: "Variance Report",
      eVolumeSold: "ATG Reading",
      mVolumeSold: "Manual Dipping",
      variance: "Variance",
      total: "TOTAL",
      reportBetween: "Company Variance Report Between",
      date: "Date/Time",
      branch: "Station",
      product: "Product",
      eVolumeSoldLtr: "Epump Volume Sold(ltr)",
      mVolumeSoldLtr: "Manual Volume Sold(ltr)",
      atgReading: "ATG Reading(ltr)",
      manualDipping: "Manual Dipping(ltr)",
      varianceLtr: "Variance(ltr)",
      tankVarianceTitle: "Tank Variance",
      region: "Region",
      state: "State",
    },
    // AssignStation In Zones
    assignBranch: {
      retailOutlets: "Retail Outlets",
      title: "Assign Retail Outlets",
      retailOutletName: "Retail Outlet Name",
      city: "City",
      state: "State",
      successfullyAssigned: "Successfully assigned Retail Outlet",
      assignOutlet: "Assign Outlet",
    },
    // Zones
    zones: {
      createAZone: "Create a zone",
      zoneName: "Zone Name",
      createZone: "CREATE ZONE",
      outletsAssigned: "Number of retail outlets assigned",
      dateCreated: "Date Created",
      viewOutlets: "View Outlets",
      assignOutlets: "Assign Outlets",
      pleaseInputZone: "Please input a zone",
      successfullyCreatedZone: "Successfully created Zone",
      successfullyDeleted: "Successfully deleted zone",
      unsuccessfulDelete: "Failed to delete zone",
      confirmDelete: "Are you sure you want to delete this zone?",
    },
    // Branches in zone
    zoneBranches: {
      assignedOutlets: "Assigned Retail Outlets",
      zonesOutlets: "Region's Assigned Retail Outlets",
      outletName: "Retail Outlet Name",
      city: "City",
      state: "State",
      unassignOutlet: "Unassign Outlet",
      successfullyUnassigned: "Successfully unassigned Retail Outlet",
      branchMissing: "Please input a station",
    },

    /****Station Portal */

    // Station Master Layout
    bMasterLayout: {
      companyDashboard: "Company Dashboard",
      dealerDashboard: "Dealer Dashboard",
      groupDashboard: "Group Dashboard",
      regionDashboard: "Region Dashboard",
      dashboard: "Dashboard",
      report: "Reports",
      inventoryReport: "Inventory Report",
      salesTransactions: "Sales Transactions",
      varianceReport: "Variance Report",
      productSummary: "Product Summary",
      pumpSummary: "Pump Summary",
      endOfDayReport: "End of the day Report",
      tankReport: "Tank Report",
      tanksFilledReport: "Product Discharged Report",
      posReport: "POS Transactions Report",
      tanks: "Tanks",
      pumps: "Pumps",
      stationManagement: "Station Management",
      updatePrice: "Update Price",
      pumpFaults: "Pump Faults",
      pumpMaintenance: "Pump Maintenance",
      eChannel: "E-channels",
      eSales: "E-sales",
      settlementAccount: "Settlement Account",
      accounting: "Accounting",
      expenses: "Expenses",
      bankAccounts: "Bank Accounts",
      peopleManagement: "People Management",
      people: "People",
      staff: "Staff",
      shift: "Shift",
      settings: "Settings",
      profile: "Profile",
      signOut: "Sign Out",
      confirmLogout: "Do you really want to logout?",
      pumpsVariance: "Pumps Variance",
      tanksVariance: "Tanks Variance",
      tanksFilled: "Tanks Filled",
      cashFlowReport: "Cash Flow Report",
      tankDippings: "Tank Dippings",
      productsFilled: "Products Filled",
      productsReceived: "Products Received",
      stockValuation: "Stock Valuation",
      productSales: "Product sales",
      manualRecords: "Manual records",
      rejectedEODrecord: "Rejected EOD record",
      dryStockSales: "Dry stock sales",
      manageServices: "Manage services",
      leases: "Rents",
      availableSpaces: "Available spaces",
      availableOccupants: "Available occupants",
      ratings: "Ratings",
      branchRating: "Station rating",
      branchRatingsBreakdown: "Station ratings breakdown",
      staffRatings: "Staff ratings",
      sufficiencyMetrics: "Sufficiency Metrics",
      manageUsers: "Manage users",
      faultsAndMaintenance: "Faults and Maintenance",
      bank: "Bank",
      bankDeposits: "Bank deposits",
      management: "Management",
      createDepositReference: "Create deposit reference",
      walletTransactions: "Wallet Transactions",
      settlementTransactions: "Settlement Transactions",
      posTerminals: "POS Terminals",
      invoices: "Invoices",
      assets: "Assets",
      supportAdmin: "Support Admin",
      logout: "Logout",
      networkError: "Network Error, Please Check Your Internet Connection",
      errorOccured: "An Error Occured",
    },
    // Station Dashboard
    bDashboard: {
      salesVTarget: "Sales vs Target",
      tanksInStation: "Tanks In Station",
      pumpsInStation: "Pumps In Station",
      tanksFilled: "Product Discharged In Station",
      pumpsAvgTime: "Pumps Average Time per Litre",
      secs: "secs",
      estimatedPumpsCalibration: "Estimated Pumps Calibration",
      pumpsFault: "Pumps Fault",
      disconnectedPumps: "Number Of Disconnected Pumps",
      offlinePumps: "Number Of Pumps Offline",
      hourlyTransactions: "Hourly Transactions By Volume",
      productGuage: "Sales gauge",
      tanksStock: "Tanks Stock Per Hour",
      salesReport: "Sales Report",
      na: "N/A",
      dailyTcount: "Daily Transaction Count",
      pmsAgo: "PMS / AGO",
    },
    // Station disconnected pumps
    bDisconnectedPumps: {
      title: "Disconnected Pumps",
      deviceId: "Device Id",
      pump: "Pump",
      date: "Date",
    },
    // Station offline pumps
    bOfflinePumps: {
      title: "Offline Pumps",
      deviceId: "Device Id",
      nozzles: "Nozzles (If Pump)",
      lastDate: "Last Date",
    },
    // Pumps average time per litre
    avgTimePerLitre: {
      title: "Pumps Average Time per Litre",
      displayName: "Display Name",
      avgTimePerLitre: "Average Time per Litre(Secs)",
      totalTime: "Total Time",
      totalSale: "Total Sale(Ltr)",
      date: "Date",
    },
    // Pumps calibration
    pumpsCalibration: {
      title: "Pumps Calibration",
      calibrationRatio: "Calibration Ratio",
      pumpName: "Pump Name",
      calibrate: "Calibrate",
      calLog: "Calibration Log",
      calibration: "CALIBRATION",
      successfullyChanged: "Successfully changed calibration",
      selectNone: "select none to calibrate all",
      tTBC: "TOGGLE TIME BOUND CALIBRATION",
      TBC: "TIME BOUND CALIBRATION",
      startingHour: "STARTING HOUR",
      selectSH: "select a starting hour",
      closingHour: "CLOSING HOUR",
      selectCH: "select a closing hour",
      curCal: "Current Cal.",
      prevCal: "Previous Cal.",
      timeBound: "Time bound",
      errorSC: "starting hour cannot be greater than or equal to closing hour",
      yes: "YES",
      no: "N0",
    },
    // Bank Accounts
    bBankAccounts: {
      noBankAccts: "Number of Bank Accounts",
      bankName: "Bank Name",
      selectBankName: "Select a Bank",
      accountNumber: "Account Number",
      accountName: "Account Name",
      inputAccountNumber: "Account Number",
      inputAccountName: "Account Name",
      bank: "Bank",
      bankCode: "Bank code",
      save: "Save",
      name: "Name",
      accountNo: "Account No.",
      delete: "Delete",
      emptyBankRecord: "You currently don't have any Bank Account record",
      confirmDelete: "Are you sure you want to delete this account?",
      selectBankError: "Please select a bank",
      selectAccountError: "Please select an account to add",
      bankAdded: "Successfully Added Bank Account",
      successfullyDeleted: "Successfully Deleted Bank Account",
      unsuccessfulDelete: "Unable to delete bank account",
      addBank: "Add Bank",
      addedBankLink: "Bank linked deposit added successfully",
      iconLinked:
        "This icon indicates linked bank accounts, this means we confirm your deposit to the account. You can have multiple linked accounts",
      removeBank: "Remove Bank",
      accountAddShow: "Accounts added will show up here",
      bankAccountRequired: "Select a bank account",
      amountRequired: "Amount is required",
      inventoryReport: "Inventory Report",
      lastFilledDate: "Last Filled Date",
      lastFilledVolume: "Last Filled Volume",
      avgProductDispensePerDay: "Average Dispense Per Day",
      bankAccounts: "Bank accounts",
      reconcileBankDepo: "Link your bank accounts to reconcile bank deposits",
      addNewBank: "Add new bank",
      bankAccountList: "List of bank accounts to the account.",
      linkedAccount:
        "This icon indicates linked bank accounts, this means we confirm",
      multipleAccounts:
        "your deposit to the account. you can have multiple linked accounts",
      removeBank: "Remove bank",
      accountsShow: "Accounts added will show up here",
      noLinkedBank: "You currently don't have any bank linked",
      bankAccountDisplay: "Bank accounts will be displayed when added",
      removeAccount: "Are you sure you want to remove this account?",
      successfullyRemoved: "Successfully removed account",
    },
    // Bank Linked Deposit
    bBankLinked: {
      title: "Bank Linked Deposits",
      addBLinked: "Add bank linked deposit",
      description: "enter amount and select bank account you want to add",
      amount: "Amount",
      selectAccount: "Select account",
      submit: "Submit",
      delete: "Delete",
    },
    // Linked Bank Account
    bLinkedBank: {
      title: "Bank accounts",
      description: "Link your bank accounts to reconcile bank deposits,",
      description2: "pay monthly subscription, etc.",
      addNewBank: "Add new bank",
      listBankAcc: "List of bank accounts",
      dateCreated: "Date Created",
      transactionRef: "Transaction reference",
      summary: "Summary",
      linked: "Linked",
      noBankLinked: "You currently don't have any bank linked",
      bankAccDisplayed: "Bank accounts will be displayed when added",
      bankTraDisplayed: "Bank linked transactions will be displayed when added",
    },
    // Bank Deposit
    bBankDeposit: {
      title: "Bank Deposits",
      genTitle: "Generate bank deposit",
      genDeposit: "Generate deposit",
      description: "enter amount and select bank account to get a reference",
      account: "Account",
      reference: "Reference",
      difference: "Difference",
      amount: "Amount",
      amountPaid: "Amount paid",
      amountRaised: "Amount raised",
      dateRec: "Date Recorded",
      depositSuccess: "Deposit generated successfully",
    },
    // Station Expenses:
    bExpenses: {
      title: "Station Expenses",
      recordExpenses: "Record Expenses",
      expenseCategory: "Expense Category",
      selectCategory: "select category",
      paymentMode: "Payment Mode",
      amount: "Amount",
      recipient: "Recipient",
      description: "Description",
      recordExpense: "Record Expense",
      dateTime: "Date/Time",
      descriptionMissing: "Please input a description",
      amountMissing: "Please input an amount",
      expenseCategoryError: "select an expense category",
      successfullyRecorded: "Successfully recorded Expense",
      successfullyDeleted: "Successfully deleted Expense",
      unsuccessfulRecord: "Unable to add expense",
      accountNumberMissing:
        "You currently don't have a bank account, please add an account first, in order to record expenses",
      cash: "Cash",
      cheque: "Cheque",
      transfer: "Transfer",
      accountNumber: "Account Number",
      selectAccount: "select account",
      category: "Category",
      account: "Account",
      paymentMode: "Payment Mode",
    },
    // Station Users
    bUsers: {
      title: "View users",
      description: "View Station Users",
      users: "Users",
    },
    // Station Wallet
    bWallet: {
      walletBalance: "Wallet Balance",
      title: "Station Wallet",
      date: "Date",
      voucherPin: "Voucher Pin",
      amountSpent: "Amount Spent",
      totalAmountSpent: "Total Amount Spent",
      product: "Product",
      salesType: "Sales type",
      identifier: "Transaction Identifier",
      salesType: "Sales type",
      bookBalance: "Book Balance",
    },
    // Station Assets Folder
    bAssets: {
      title: "Total  Assets",
      bAssets: "Station Assets",
      pAssets: "Parent assets",
      here: "here",
      create: "CREATE ASSET",
      selectStatus: "Select A Status",
      allStatus: "All Status",
      okay: "Okay",
      serviceDue: "Service Due",
      renewalDue: "Renewal Due",
      notActive: "Not Active",
      renewed: "Renewed",
      selectGroup: "Select A Group",
      allGroups: "All Groups",
      licenseNo: "License No.",
      assetGroup: "Asset Group",
      description: "You can create and manage your station assets",
      noAssets: "You currently don't have any assets",
      addAssets: "Add a new asset",
      enterAssets: "Enter asset #",
    },
    // Station Settlement
    bSettlement: {
      title: "Total Settlements",
      history: "Settlement History",
      transactionBtw: "Retail Outlet wallet transactions between",
      amount: "Transaction Amount",
      source: "Source",
      transactionId: "Transaction ID",
      sessionId: "Session ID",
      settlement: "Settlement",
      settlementRequest: "Settlement request",
      settlementRequestDesc: "View and manage settlement requests here",
      makeSetRequest: "Make settlement request",
      settleWalletAmt: "Settle wallet amount",
      settleCustomAmt: "Settle custom amount",
      inputGreater: "Inputed amount is greater than wallet balance",
      selectAccType: "Select Account Type",
      approved: "Approved",
      unapproved: "Unapproved",
      comAct: "Company Account",
      braAct: "Station Account",
    },
    // Station Sufficiency
    bSufficiency: {
      title: "Sufficiency Metrics",
      tprojectionR: "Tank Projection Rate",
      selectIorD: "Select Increase or Decrease",
      increase: "Increase",
      decrease: "Decrease",
      inputPercent: "Input Percentage",
      nextTwoDaysVol: "Next 2 days vol. projection",
      nextTwoDaysSales: "Next 2 days Sales projection",
      noTanksAdded: "No tanks added",
    },
    // Station Cashflow
    bCashFlow: {
      title: "Cash Flow",
      titleBtw: "Cash flow between",
      totalSales: "Total Sales",
      posSales: "POS Sales",
      retainerSales: "Retainer Sales",
      epumpSales: "Epump Sales",
      bankedCash: "Banked Cash",
      expense: "Expense",
      previousBalance: "Previous Balance",
      outstandingCash: "Outstanding Cash",
      cashInsuranceRatio: "Cash Insurance Limit",
      compliance: "Compliance(%)",
    },
    // Station Dry Stock
    bSales: {
      // Create Sales
      sale: "sale",
      products: "Products",
      unitPrice: "Unit Price",
      quantitySold: "Quantity sold",
      addSale: "Add sale",
      totQty: "Total quantity:",
      totPrice: "Total price:",
      applyDiscount: "Apply discount",
      enterDiscountAmt: "Enter discount amount",
      enterCustomerName: "Enter customer name",
      addSalesWarning: "You currently don't have any sale added",
      suppWillAdd: "Supplies will be added here when added",
      reqUnitPrice: "Unit price is required",
      reqUnitQty: "Quantity supplied is required",
      reqUnitProd: "product is required",
      salesAdded: "Sale  added successfully",
      reqQtySold: "Quantity sold is required",
      reqSupplyTo: "Please select a supply to",
      salesUpdated: "Sale updated successfully",
      //Sales
      dsSales: "Dry stock sales",
      manageDS: "Manage your dry stock sales here...",
      recordSale: "Record sale",
      recordSupply: "Record supply",
      totSales: "Total sales",
      totSoldPrice: "Total sold price",
      totQtySold: "Total Quantity sold",
      dateSold: "Date sold",
      quantitySold: "Quantity sold",
      totalSoldPrice: "Total price",
      discountPrice: "Discount price",
      customer: "Customer",
      //Sales Details
      productSales: "Product Sales",
      nonWetProductName: "Product name",
      productCategoryName: "Product category",
      // Product Sales
      managePS: "Manage your product sales here...",
      openingRead: "Opening reading",
      closingRead: "Closing reading",
      vol: "Volume",
      amt: "Amount",
      priceSold: "Price sold",
      nozzle: "Nozzle",
      transactionType: "Transaction type",
      operatingHours: "Operating Hours",
    },
    //Station Supply
    bSupply: {
      title: "Manage dry stock supplies",
      station: "Station",
      description: "Manage your  dry stock supplies here...",
      totSupply: "Total supplies",
      totProSup: "Total products supplied",
      totQtySup: "Total Quantity supplied",
      companyName: "Company Name",
      totalCostProductsSupplied: "Total cost",
      totalProductQuantitySupplied: "Total products quantity supplied",
      totalProductsSupplied: "Products supplied",
      //Supply Details
      title2: "Dry stock supply details",
      description2: "View your dry stock supply details here...",
      product: "Product",
      productCategoryName: "Category name",
      qtySupplied: "Quantity supplied",
      isSupplyAccepted: "Supply accepted",
      isSupplyCompleted: "Supply completed",
    },
    //Station Settingg
    bSettings: {
      title: "Station Settings",
      useCompanySet: "Use Company Settings",
      showDS: "Show Dry Stock",
      showMM: "Show Mobile Money",
      selectMRfromMR: "Select Meter Readings for Manual Record",
      selectMRfromCalc: "Select Manual Reading for Calculation",
      updateSettings: "Update Settings",
      updateSuccess: "Successfully Updated Station Settings",
      multiMR: "Multiple Manual Records",
    },
    // Station Invoice
    bInvoices: {
      title: "Invoices",
      overdue: "Overdue",
      last: "Last",
      due30: "Due within next 30 days",
      allStatus: "All Status",
      paid: "Paid",
      partPaid: "PartPaid",
      allInvoices: "All Invoices",
      status: "Status",
      dateTemp: "Due",
      amountDue: "Amount Due",
      invoicePayments: "Invoice Payments",
      billTo: "Bill to",
      invoiceNo: "Invoice number:",
      invoiceDate: "Invoice date",
      paymentDue: "Payment due:",
      amountDue: "Amount Due:",
      items: "Items",
      qty: "Quantity",
      price: "Price",
      amt: "Amount",
      noAddedItems: "You have not added any items.",
      subTot: "Sub Total:",
      total: "Total:",
      amtPaid: "Amount Paid:",
      noInvoiceSelected:
        "No invoice selected. Please select an invoice to view",
      totAmtPaid: "Total Amount Paid",
      payments: "Payments",
      paymentMtd: "Payment Method",
      note: "Note",
    },
    // Station Lease Folder
    bLease: {
      title: "Manage Rents",
      lDescription: "Manage your rents here...",
      createLease: "Create rent",
      paymentDate: "Payment date",
      isRequest: "is required",
      successfullyCreatedLease: "Successfully created rent payment record",
      successfullyUpdatedLease: "Successfully updated rent payment record",
      manageBspace: "Manage station space",
      BSdescription: "Manage your station space here...",
      createBS: "Create station space",
      totCount: "Total count",
      branchSpace: "Station space",
      rooms: "Rooms",
      durations: "Rent duration(s)",
      isAvailable: "Available",
      propertyName: "Property Name",
      rentFee: "Rent fee",
      noRooms: "Number of rooms",
      noRestRoom: " Number of rest rooms",
      restRoom: "Rest Rooms",
      rentDuration: "Rent duration",
      propDesc: "Property Description",
      addSet: "Additional details",
      propNameReq: "Property name is required",
      noRoomReq: "number of rooms is required",
      noRestroomReq: "number of rest rooms is required",
      propDescReq: "property Description is required",
      addDetReq: "Additional details are required",
      allMissingData: "Fill out all missing fields",
      successfullyCreatedBS: "Successfully created station space",
      successfullyCreatedBL: "Successfully created station rent",
      successfullyCreatedBO: "Successfully created station occupant",
      successfullyUpdatedBS: "Successfully updated station space",
      successfullyUpdatedBL: "Successfully updated station rent",
      successfullyUpdatedBO: "Successfully updated station occupant",
      newUser: "New User",
      existingUser: "Existing user",
      leaseInfo: "Rent information",
      rentPaid: "Rent paid",
      rentDate: "Rent date",
      exDate: "Expiry date",
      availableBs: "Available Station space",
      selectBS: "select station space",
      selectRentDur: "Select rent duration",
      rentDurLength: "Rent duration length",
      availableOccupants: "Available Occupants",
      seleceOcc: "select occupant",
      leasedBy: " Rented by",
      userDetails: "User details",
      rentPaidRequired: "Rent paid is required",
      rentDurationRequired: "Rent duration is required",
      rentDurLenRequired: "Rent duration length is required",
      leasedByRequired: "Rented by is required",
      btw1013: "should be between 10 & 13 characters",
      inputAvalid: "Please input a valid",
      allRentLease: "All Rents",
      rentDate: "Rent date",
      occ: "Occupant",
      occupantName: "Occupant name",
      occupantEmail: "Occupant Email",
      manageOcc: "Manage occupants",
      occDescription: "Manage your station occupants here...",
      createBranchOcc: "Create station occupant",
      managePaymentRec: "Manage payment records",
      mprDescription: "Manage payment records for your rent here...",
      addPR: "Add payment record",
      outstandingAmt: "Outstanding amount",
    },
    // Station Manual Records
    bManualRec: {
      title: "Manual Record",
      description:
        "Record all your pumps, tanks, expenses and POS transactions",
      setZeroSales: "Set Zero Sales",
      outerMeter: "Outer Meter",
      selectReportDate: "Select Report Date",
      openingRead: "Opening Read",
      closingRead: "Closing Read",
      totOuterSales: "Total Outer Sales",
      innerMeter: "Inner Meter",
      totInnerSales: "Total Inner Sales",
      rtt: "Return To Tank",
      trf: "Transfer",
      openingDip: "Opening Dip (ltrs)",
      closingDip: "Closing Dip (ltrs)",
      closingDipT: "Closing Dip Time",
      volDisc: "Volume Discharged (ltrs)",
      totEx: "Total expense",
      mmSales: "Mobile Money Sales",
      pumpReading: "Pump Readings",
      tankReading: "Tank Readings",
      innerOpeningReading: "Inner Opening Reading",
      outerOpeningReading: "Outer Opening Reading",
      innerClosingReading: "Inner Closing Reading",
      outerClosingReading: "Outer Closing Reading",
      innerTotSales: "Inner Total Sales",
      outerTotSales: "Outer Total Sales",
      otherSummary: "Other Summary",
      totRetSales: "Total Retainership Sales",
      totPOSsales: "Total POS Sales",
      totMMsales: "Total Mobile Money Sales",
      previous: "Previous",
      rttError: "RTT cannot be greater than sales",
      openGreaterClose: "Opening cannot be greater than closing",
      dipPlusDischargeError:
        "Incorrect values: Closing dip cannot be more that Opening Dip + Discharge",
      summarySuccess: "Successfully submitted summary",
      rejectedEOD: "Rejected EOD Records",
      recordType: "Record Type",
      updatedReject: "Update Rejected Record for",
      oirm: "Opening Read (Inner Meter)",
      orom: "Opening Read (Outer Meter)",
      cirm: "Closing Read (Inner Meter)",
      crom: "Closing Read (Outer Meter)",
      updateRecord: "Update Record",
      recordUpdated: "Record successfully updated",
    },
    // End of day report
    endOfDayReport: {
      title: "End of the day Report",
      hours: "hours",
      usageTime: "Usage Time",
      totalVolumeSold: "Total Volume Sold",
      totalRtt: "Total RTT",
      totalSales: "Total Sales",
      totalCashSale: "Total Cash Sale",
      epumpSales: "E-Sale",
      retainershipSales: "Retainership Sale",
      accountSummary: "Account Summary",
      cashSales: "Cash Sales",
      cashAtHand: "Cash At Hand",
      cashToBank: "Cash To Bank",
      pos: "POS",
      returnToTank: "Return To Tank",
      expense: "Expense",
      salesSummary: "Sales Summary",
      pumpSales: "Pump Sales",
      tankSales: "Tank Sales",
      operatingHours: "Operating Hours",
      surplus: "Surplus",
      totOfflineSales: "Total Offline Sales",
      esalesSummary: "Esales Summary",
      retainershipSales: "Retainership Sales",
      swipeCardSales: "Swipe Card Sales",
      ussdSales: "USSD Sales",
      voucherSales: "Voucher Sales",
    },
    // People Management
    // Edit Staff, Add Staff and View Staff
    editStaff: {
      title: "Edit Staff",
      personalInformation: "Personal Information",
      firstName: "First Name",
      lastName: "Last Name",
      cardName: "Card Name",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      male: "Male",
      female: "Female",
      email: "Email",
      contactInformation: "Contact Information",
      streetAddress: "Street Address",
      city: "City",
      state: "State",
      country: "Country",
      phone: "Phone No.",
      updateStaff: "Update Staff",
      cardNameMissing: "Please input a card name",
      dateOfBirthMissing: "Please select a date of birth",
      genderMissing: "Please select a gender",
      countryMissing: "Please input a country",
      successfullyUpdated: "Successfully updated staff",
      unsuccessfulUpdate: "Failed to update staff records",
    },
    // Add Staff
    addStaff: {
      title: "Add New Staff",
      successfullyAdded: "Successfully Added Staff",
      unsuccessfulAdd: "Failed to add Staff",
    },
    viewStaff: {
      title: "Staff Details",
    },
    // Staff
    staff: {
      title: "Manage Staffs",
      description: "You can view and manage all your staffs here...",
      noOfStaffs: "Number of Staffs",
      addNew: "Add New",
      fuelCard: "Fuel Card",
      gender: "Gender",
      view: "View",
      edit: "Edit",
      delete: "Delete",
      noStaff: "No Staff created yet",
      confirmDelete: "Are you sure you want to delete this staff?",
      successfullyDeleted: "Successfully deleted staff",
      unsuccessfulDelete: "Failed to delete staff",
      totalStaffs: "Total staffs",
      staffName: "Staff name",
      avgRV: "Average rate value",
      totSale: "Total sale",
      totPriceSold: "Total price sold",
      mapCard: "MapCard",
      unMapCard: "UnMapCard",
      cardId: "Card ID",
      map: "Map",
      toCard: "to Card",
      inputCardId: "Input Card ID",
      inputPin: "Input pin",
    },
    //Staff Ratings
    staffRatings: {
      title: "Staff ratings breakdown",
      description: "you can View the your staff ratings here...",
      allRec: "All records",
      selectStaff: "select staff",
      rateValue: "Rate Value",
    },
    // Shift
    shift: {
      totalShifts: "Total Number of Shifts",
      shiftDetails: "Shift Details",
      addShift: "Add Shift",
      shiftName: "Shift Name | SHIFT NAME",
      addShift: "Add Shift",
      startTime: "Start Time",
      endTime: "End Time",
      status: "Status",
      enterShift: "Enter Shift",
      shiftMissing: "Please input a shift",
      successfullyCreated: "Successfully created Shift",
      unsuccessfullyCreated: "Failed to add Shift",
      assignments: "Assignments",
      deposits: "Deposits",
      manageShift: "Manage shifts",
      decription: "You can view and manage all  your shifts here...",
      totalStaffs: "Total staffs",
    },
    // Shift Assignments
    shiftAssignments: {
      totalShiftAss: "Total Shift Assignments",
      shiftAss: "Shift Assignments",
      pumpName: "Pump Name",
      staffName: "Staff Name",
      openingReading: "Opening Reading | OPENING READING",
      closingReading: "Closing Reading",
      startNew: "Start New Shift",
      pump: "PUMP",
      selectPump: "Select Pump",
      staff: "STAFF",
      chooseStaff: "Choose Staff",
      assignShift: "Assign Shift",
      openingReadingMissing: "Please input an opening Reading",
      staffMissing: "Please choose a staff",
      pumpMissing: "Please select a pump",
      successfullyAssigned: "Successfully assigned Shift",
      unsuccessfullyAssigned: "Failed to assign Shift",
      manageShiftAss: "Manage shift assignments",
      description:
        "You can view and manage all  your shift assignments here...",
      totalStaffs: "Total staffs",
    },
    // Shift Deposits
    shiftDeposits: {
      totalShiftDeposit: "Total Shift Deposits",
      shiftDeposits: "Shift Deposit | Shift Deposits",
      bank: "Bank",
      amount: "Amount",
      balance: "Balance",
      tellerNumber: "Teller Number",
      selectBank: "Select Bank",
      submit: "Submit",
      selectPump: "Select Pump",
      chooseStaff: "Choose Staff",
      bankMissing: "Please select a bank",
      amountMissing: "Please input an amount",
      tellerMissing: "Please input a valid teller number",
      successfullyCreated: "Successfully creatd Shift Deposit",
      unsuccessfullyCreated: "Failed to create Shift Deposit",
      amountZeroError: "Please input an amount greater than 0",
      amountZeroError: "Please input an amount greater than 0",
      bankAccountError:
        "You currently don't have a bank account record, please create an account to enable shift deposits",
    },
    //Station POS
    bPos: {
      selectStatus: "Select Status",
      showAll: "Show All",
      approved: "Approved",
      declined: "Declined",
      totTransact: "Total Transactions",
      successfulTransactions: "Successful Transactions",
      failedTransactions: "Failed Transactions",
      totChargeback: "Total Cashback Charges",
      posTransactBtw: "POS transactions between",
      transactionDate: "Transaction Date",
      stan: "Stan",
      pump: "Pump",
      amount: "Amount",
      rrn: "RRN",
      maskedPan: "Masked Pan",
      youCan: "You can assign and re-assign POS to a selected station here",
    },
    //Station POS Terminal
    bTerminal: {
      title: "POS Terminal",
      description:
        "You can view and manage terminals created for this station here ",
      createTerminal: "create terminal",
      allTerminals: "All Terminals",
      terminalId: "Terminal Id",
      serialNo: "Serial No.",
      station: "Station",
    },
    // Product Summary
    productSummary: {
      totalTransactions: "Total Transactions",
      title: "Product Summary",
      transBtw: "Products Summary between",
      date: "Date",
      productVolume: "Volume (ltr)",
      productAmount: "Amount {currency}",
      total: "Total",
      totalAmount: "Total Amount",
    },
    // Product Valuation
    bproductValuation: {
      title: "Stock  valuation",
      noValuationRec: "No stocks valuation recorded",
      currentVolume: "Current Volume",
      valuation: "valuation",
    },
    // Station Profile
    bProfile: {
      accountSettings: "Account Settings",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      editProfile: "Edit Profile",
      changeYourPassword: "Change Your Password",
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      changePassword: "Change Password",
      successfullyChanged: "Successfully changed Password!",
      fillIn: "Fill in the missing Fields",
      updated: "Profile updated successfully",
      passwordBlank: "Password field cannot be blank",
      passwordsDontMatch: "Passwords don't match",
    },
    //Station Services
    bServices: {
      title: "Manage Services",
      description: "Manage your  services for",
      descriptionT: "View your transaction details for",
      manageTfor: "Manage your transactions for",
      service: "Service",
      selectService: "select service",
      transaction: "transaction",
      transactionDet: "Transaction details",
      manageTransaction: "Manage transaction",
      unitprice: "Unit price",
      serviceDescription: "Service description",
      addTransaction: "Add transaction",
      removeItem: "Remove item",
      totalPrice: "Total Price",
      enterCustomerName: "Enter customer name",
      customerName: "Customer name",
      submitTransaction: "Submit transaction",
      noTransactAdded: "You currently don't have any transaction added",
      transactWillAdd: "transactions will be added here when added",
      unitPriceReq: "Unit price is required",
      kindlySelectService: "Kindly select a service",
      serviceDescReq: "service description is required",
      customerNameReq: "Customer name is required",
      nonwetProSupplyCreated: "Non wet product supply created successfully",
      plsSelectBranch: "Please select a branch",
      here: "here",
      totalServices: "Total services",
      totalTransact: "Total Transactions",
      serviceName: "Service name",
      transactionHistory: "Transaction History",
      recordDate: "Record date",
      serviceName: "Service name",
      price: "Price",
      descTion: "Description",
      comService: "Company service",
      addTransactions: "Add transaction",
      totSoldPrice: "Total sold price",
      customer: "Customer",
    },
    // Pumps
    pumps: {
      showAll: "Show All",
      installedPumps: "Installed Pumps",
      lastReading: "Last Reading",
      manufacturer: "Manufacturer",
      sourceTank: "Source Tank",
      details: "Details",
      noPumpsAdded: "No Pump Added",
      transactions: "Transactions",
    },
    // Pump Summary
    pumpSummary: {
      title: "Pump summary",
      description: "Manage your pump summary here...",
      totRec: "Total records",
      pump: "Pump",
      amt: "Amount",
      vol: "Volume",
    },
    // Pump Transactions
    pumpTransactions: {
      totalTransactions: "Total Transactions",
      title: "Pump Transactions",
      totalVolume: "Volume dispensed",
      totalNumber: "No. of Transactions",
      totalAmount: "Amount sold",
      avgLitres: "Avg. Litres per Transaction",
      branchSales: "Retail Outlet Pump transactions between",
      dateTime: "Date/Time",
      pumpName: "Pump Name",
      productName: "Product Name",
      pricePerLitre: "Price / Litre",
      openingReading: "Opening Reading",
      closingReading: "Closing Reading",
      priceSoldCash: "Price Sold Cash",
      volumeDispensed: "Volume Dispensed",
      dispensedBy: "Dispensed By",
      salesType: "Sales Type",
    },
    // Pump Details
    pumpDetails: {
      details: "Details",
      pumpDisplayName: "Pump Display Name",
      associateTank: "Associate Tank",
      pumpCalibration: "Pump Calibration xtr-20ltr",
      manufacturer: "Pump Manufacturer",
      pumpModel: "Pump Model",
      pumpStatus: "Pump Status",
      title: "Pump Details",
      pumpName: "Pump Name",
      associatePumpToTank: "Associate Pump to Tank",
      pumpReading: "Pump Reading",
      throughput:
        "Pump Average Throughput / Product Average Throughput for 7 days",
      throughputPlaceholder: "Pump Throughput",
    },
    // Pumps Fault
    pumpsFault: {
      total: "Total Pump Faults",
      totalFaults: "Total Number of Faults",
      showAll: "Show All",
      pending: "Pending",
      fixing: "Fixing",
      fixed: "Fixed",
      notFixed: "Not Fixed",
      pumpStatus: "Pump Status",
      title: "Pump Faults",
      recordFault: "Record Fault",
      describeFault: "Describe fault",
      fault: "Fault",
      addFault: "Add Fault",
      faults: "Faults",
      pump: "Pump",
      type: "Type",
      date: "Date",
      station: "Station",
      name: "Name",
      recordedBy: "Recorded By",
      selectPump: "Select Pump",
      status: "Status",
      selectPumpStatus: "Select Status",
      urgencyLevel: "Urgency Level",
      date: "Date",
      editFault: "Edit Fault",
      updateFault: "Update",
      addNewFault: "Create",
      pumpName: "Pump Name",
      faultMissing: "Please input a fault",
      faultCreated: "Fault created successfully",
      faultUpdated: "Fault updated successfully",
      faultUnupdated: "Fault unpdate failed",
      statusMissing: "Please select a status",
      pumpMissing: "Please select a pump",
      typeMissing: "Please select a type",
      tankMissing: "Please select a tank",
      issuesMissing: "Please state your issues",
      urgencySelMissing: "Select an urgency level",
      urgencyMissing: "Please input an urgency level",
      confirmDelete: "Are you sure you want to delete this pump fault?",
      confirmDeleteFault: "Are you sure you want to delete this fault record?",
      successfullyDeleted: "Pump Fault Deleted Successfully",
      unsuccessfulDelete: "Failed To Delete Pump Fault",
      successfullyAdded: "Successfully Added Pump Fault",
      unsuccessfulAdd: "Failed to add Pump Fault",
      successfullyEdited: "Successfully Edited Pump Fault",
      unsuccessfulEdit: "Failed to edit pump fault",
      faultsAndMaint: "Faults and Maintenance",
      selectType: "Select type",
      tank: "Tank",
      others: "Others",
      optionsSelected: "options selected",
      otherFaults: "Other faults",
      low: "Low",
      medium: "Medium",
      high: "High",
      recBy: "Recorded By",
      aggregatedFault: "Aggregated Faults",
      viewFault: "View your aggregated Dealer faults here...",
      totalFaults: "Total Faults",
      maintenanceList: "Maintenance List",
      viewMaintenanceList: "View your dealer maintenance list here...",
      totalMaintenance: "Total Maintenance",
      viewAggregatedFault: "View your aggregated group faults here...",
      viewAggregatedRegionFault: "View your aggregated region faults here...",
      totalFaults: "Total faults",
    },
    // Pumps Maintenance
    pumpsMaintenance: {
      total: "Total Pump Maintenance",
      showAll: "Show All",
      pending: "Pending",
      fixing: "Fixing",
      fixed: "Fixed",
      notFixed: "Not Fixed",
      resolved: "Resolved",
      maintenence: "Maintenance",
      totalMaintenence: "Total Maintenance",
      pumpStatus: "Pump Status",
      title: "Pump Maintenance",
      recordMaintenance: "Record Maintenance",
      fault: "Fault",
      pickSome: "Pick some",
      selectFault: "Select Fault",
      servicingCompany: "Servicing Company",
      technicianName: "Technician Name",
      remarks: "Remark",
      findings: "Findings",
      keyReturned: "Key Returned",
      trueOrFalse: "Select true or false",
      true: "True",
      false: "False",
      pumpFunctional: "Pump Functional",
      date: "Date",
      update: "Update",
      create: "Create",
      editMaintenance: "Edit Maintenance",
      pumpName: "Pump Name",
      technician: "Technician",
      status: "Status",
      faultMissing: "Please select a pump fault",
      servicingMissing: "Please input the servicing company",
      technicianMissing: "Please input the technician's name",
      remarkMissing: "Please input a remark",
      findingMissing: "Please input findings about the pump",
      keyReturnedMissing: "Please select true or false for key returned",
      pumpFunctionalMissing: "Please select true or false for pump functional",
      confirmDelete: "Are you sure you want to delete this pump maintenance?",
      successfullyDeleted: "Successfully deleted Pump Maintenance",
      unsuccessfulDelete: "Failed To Delete Pump Maintenance",
      successfullyAdded: "Successfully Added Pump Maintenance",
      unsuccessfulAdd: "Failed to add Pump Maintenance",
      successfullyEdited: "Successfully Updated Pump Maintenance",
      unsuccessfulEdit: "Failed to edit pump maintenance",
    },
    // Station Rating
    bRating: {
      title: "Station Transaction Rating",
      title1: "Station Ratings",
      description: "you can View the your station ratings here...",
      addRating: "Add Rating",
      rateValueWarning: "please select rate value",
      branchIdWarning: "Station ID is required",
      userIdWarning: "User ID is required",
      ratingAdded: "Transaction Rating Added Successfully!",
      totalSale: "Total sale",
      totalPriceSold: "Total price sold",
      avgRateValue: "Average rate value",
      allRec: "All records",
      staffName: "Staff Name",
    },
    // Sales Transactions
    salesTransactions: {
      totalTransactions: "Total Transactions",
      showAll: "Show All",
      productFilter: "Product Filter",
      title: "Sales Transactions",
      total: "Total",
      transBtw: "Retail Outlet sales transactions between",
      date: "Date",
      pumpName: "Pump Name",
      product: "Product",
      openingReading: "Opening Reading",
      closingReading: "Closing Reading",
      totalDispensed: "Total Dispensed",
      amount: "Amount",
      viewTransactions: "View Transactions",
    },
    // Settlement Account
    settlementAccount: {
      addNewAccount: "Add New Bank Account",
      bankName: "Bank Name",
      selectBankName: "Select a Bank",
      accountName: "Accout Name | ACCOUNT NAME",
      accountNumber: "Account Number | ACCOUNT NUMBER",
      payTime: "PAY TIME",
      endOfTheDay: "At the end of the day",
      endOfDayValue: "End of the day",
      minimumValue: "Set a minimum value",
      setAValue: "Set a value",
      createBankDetails: "Create Bank Details",
      updateBankDetails: "Update Bank Details",
      bankMissing: "Please select a bank",
      payTimeMissing: "Please choose a paytime",
      minValueMissing: "Please set a minimum value",
      successfullyAdded: "Successfully Added Bank Details",
      unsuccessfulAdd: "Failed to add settlement account",
      successfullyUpdated: "Sucessfully updated account details",
      unsuccessfulUpdate: "Failed to update account details",
    },
    // Station Station Management
    stationManagement: {
      product: "PRODUCT",
      price: "PRICE",
      selectProduct: "Select Product",
      enterNewPrice: "Enter new price",
      updatePrice: "Update Price",
      currentPrice: "Current Price",
      currentlySellingAt: "Currently selling at",
      priceMissing: "Please input a new price",
      invalidPrice: "Please input a valid amount",
      successfullyChanged: "Successfully changed price",
    },
    // Tank Report
    tankReport: {
      title: "Tank Reports",
      reportBetween: "Tanks Report between",
      tankName: "Tank Name",
      saleVolume: "Sale Volume",
      volumeRefilled: "Volume Refilled",
      openingVolume: "Opening Volume",
      closingVolume: "Closing Volume",
      volumeSold: "Volume Sold",
      volumeFilled: "Volume Filled",
      totalVolume: "Total Volume (Litres)",
    },
    // Tanks
    tanks: {
      title: "Tanks",
      productVolume: "Product Volume",
      tankCapacity: "Tank Capacity",
      waterLevel: "Water Level",
      details: "Details",
      probeTransactions: "Probe Transactions",
      noTanksAdded: "No Tanks Added",
      stock: "Tank Stock",
      consoleStatus: "CONSOLE STATUS",
    },
    // Tank Dippings
    tankDippings: {
      title: "Tank Dippings",
      tankName: "Tank Name",
      probeVol: "Probe Volume(Ltrs)",
      actVol: "Actual Volume(Ltrs)",
      difference: "Difference(Ltrs)",
      productName: "Product Name",
    },
    // Tank Details
    tankDetails: {
      title: "Tank Details",
      ago: "ago",
      productVolume: "Product Volume",
      waterVolume: "Water Volume",
      tankCapacity: "Tank Capacity",
      waterLevel: "Water Level",
      probeTransactions: "Probe Transactions",
      associatedPumps: "Associated Pumps",
      currentReading: "Current Reading",
      transactions: "Transactions",
      graphTitle: "Tank stock graph for the past seven(7) days",
      volumeLitres: "Volume (Litres)",
    },
    // Probe Transactions
    probeTransactions: {
      title: "Probe Transactions",
      transBetween: "Probe Transactions between",
      transDate: "Transaction Date",
      productHeight: "Product Height",
      productVolume: "Product Volume",
      temperature: "Temperature",
      waterHeight: "Water Height",
      waterVolume: "Water Volume",
    },
    // Product Filled
    bproductFilled: {
      title: "Products Filled",
      titleOn: "Products filled on",
      pmsVolume: "PMS Volume",
      agoVolume: "AGO Volume",
      dpkVolume: "DPK Volume",
      lpgVolume: "LPG Volume",
    },
    // Product Received
    bProductReceived: {
      title: "Total Products Received",
      description: "Total Products Received Between",
      totalVolume: "Total Volume",
      product: "Product",
    },
    // Tanks Filled
    tanksFilled: {
      title: "Product Discharged",
      tanksFilledOn: "Products Discharged On",
      tankName: "Tank name",
      eVolumeDischarged: "Epump Volume Discharged(ltr)",
      mVolumeDischarged: "Manual Volume Discharged(ltr)",
      variance: "Variance",
      eStartVolume: "Epump Start Volume(ltr)",
      eVolumeEnd: "Epump End Volume(ltr)",
      mStartVolume: "Manual Start Volume(ltr)",
      mEndVolume: "Manual End Volume(ltr)",
      startTime: "Start Time",
      endTime: "End Time",
      noTanksFilledOn: "No Products Discharged On",
      efuelingTF: "Efuelling TanksFill",
      manualTF: "Manual TanksFill",
      totalTF: "Total TanksFill",
    },
    // Station Variance Report
    bVarianceReport: {
      totalTransactions: "Total Transactions",
      showAll: "Show All",
      productFilter: "Product Filter",
      title: "Variance Report",
      eVolumeSold: "Epump Volume Sold (ltr)",
      mVolumeSold: "Manual Volume Sold (ltr)",
      variance: "Variance",
      total: "TOTAL",
      reportBetween: "Variance Report Between",
      date: "Date",
      product: "Product",
      pumpName: "Pump Name",
      eVolumeSoldLtr: "Epump Volume Sold(ltr)",
      mVolumeSoldLtr: "Manual Volume Sold(ltr)",
      atgReading: "ATG Reading(ltr)",
      manualDipping: "Manual Dipping(ltr)",
      varianceLtr: "Variance(ltr)",
      eOpeningReading: "Epump Opening Reading(ltr)",
      mOpeningReading: "Manual Opening Reading(ltr)",
      eLastReading: "Epump Last Reading(ltr)",
      mLastReading: "Manual Last Reading(ltr)",
      viewTransactions: "View Transactions",
      tankVariance: "Tank Variance",
    },
    // Customer account
    // Customer Master Layout
    cusMasterLayout: {
      customer: "CUSTOMER",
      dashboard: "Dashboard",
      balance: "Balance",
      voucher: "Voucher",
      vouchers: "Vouchers",
      vehicles: "Vehicles",
      allVehicles: "All Vehicles",
      drivers: "Drivers",
      fuelConsumption: "Fuel Consumption",
      fuelBalance: "Fuel Balance",
      consumption: "Consumption",
      retainership: "Retainership",
      generatedVoucher: "Generated Voucher",
      outstandingPayments: "Outstanding Payments",
      payments: "Payments",
      subscriptionExpire: "YOUR SUBSCRIPTION WILL EXPIRE in",
      subAccounts: "Sub Accounts",
      pleasePay: ", PLEASE MAKE PAYMENT",
      profile: "Profile",
      reports: "Reports",
      extendedReport: "Extended Report",
      signOut: "Sign Out",
      pumpVariance: "Pump Variance",
      tankVariance: "Tank Variance",
      tanksFilled: "Tanks Filled",
      tankStock: "Tank Stock",
      branchSales: "Station Sales",
      remisCards: "Remis Cards",
      dealerSalesSummary: "Dealer Sales Summary",
      productsDischarged: "Products Discharged",
      stockValuation: "Stock Valuation",
      confirmLogout: "Do you really want to logout?",
      logout: "Logout",
      noAccess:
        "Sorry you do not have access to this page click below to return to your dashboard",
      expired: "YOUR SUBSCRIPTION HAS EXPIRED, PLEASE MAKE PAYMENT",
      companyDashboard: "Company Dashboard",
      dailyBranchTransactions: "Daily Station Transactions",
      sendBranchReport: "Send station report",
      retailOutlet: "Retail Outlets",
      management: "Management",
      expenses: "Expenses",
      expenseCategory: "Expense Categories",
      dealerFault: "Aggregated Dealer Faults",
      maintenance: "Maintenance",
      supportAdmin: "Support Admin",
      logout: "Logout",
      cashFlow: "Cash Flow",
      groupSalesSummary: "Group Sales Summary",
      stationSales: "Station sales",
      youHave: ", you have",
      sales: "Sales",
      supplies: "Supplies",
      manualRecords: "Manual Records",
      dryStock: "Dry stock",
      bank: "Bank",
      regionSalesSummary: "Region Sales Summary",
      regionProductStock: "Region Product Stock",
    },
    // Customer Dashboard
    cusDashboard: {
      balance: "Balance",
      fuelPoints: "Fuel Points",
      vehicles: "Vehicles",
      fuelConsumed: "Fuel Consumed",
      litres: "Litres",
      vouchers: "Vouchers",
      quickDetails: "Quick Details",
      newVouchersGenerated: "New vouchers generated",
      vouchersTransfered: "Vouchers Transfered",
      vouchersExpired: "Vouchers Expired",
      showMore: "Show More",
      last10Trans: "Last 5 Transactions",
      date: "Date",
      status: "Status",
      amount: "Amount",
      remark: "Remark",
      currentBalance: "Current Balance",
      showMore: "Show More",
      drivers: "Drivers",
      subAccounts: "Sub Accountss",
      fuelConsumptionStats: "Fuel Consumption Statistics",
      totalVolume: "Total Volume (Litres)",
      voucherSummary: "Voucher summary for today",
    },
    // extended report
    extendedReport: {
      extendedReport: "Extended Report",
      excelReport: "Excel Report",
      fundWallet: "Fund Wallet",
      bankTransfer: "Bank Transfer",
      creditCard: "Fund with card",
      bankDeposit: "Via bank deposit",
      funding: "Wallet would be funded once payment is recieved",
      form: "Fill the form below to fund your account through bank deposit",
      bank: "Bank",
      name: "Depositor's name",
      slipNumber: "Deposit slip number",
      amount: "Amount",
      datepaid: "Date paid",
      request: " Request to fund",
      quickFuel: "Quick Fuel",
      quick: "Add Quick Fuel Method",
      phone: "Phone Number",
      cardBalance: "Card Balance",
      fundCard: "Fund Card",
      changePin: "Change Pin",
      blockCard: "Block Card",
      cardTrans: "Card Transactions",
      date: "Date",
      index: "Index",
      amountNaira: "Amount(Naira)",
      type: "Type",
      description: "Description",
      fund: "Fund from Wallet",
      wallet: "Fund your card from your wallet",
      fundRemis: "How much will you like to fund your remis card with",
      pay: "Fund your remis card by doing a transfer to the following bank details",
      providus: "Providus",
      fundCardNoti: "card amount is required",
    },

    // customer cards
    cards: {
      allCards: "All Cards",
      cards: "Cards",
      remisCards: "Remis Cards",
      cardNumber: "Card Number",
      amount: "Amount",
      expiryDate: "Expiry Date",
      user: "User",
      locked: "Locked",
      action: "Action",
      numberOfCards: "Number of Cards",
      vehicleCards: "Vehicle Cards",
      consumedAmount: "Consumed amount",
      usageLocation: "Usage location",
      location: "Location",
      ownerEmail: "Owner's email",

      returnBalance: "Return balance",
      vehicle: "Vehicle",
    },

    // Customer Drivers
    drivers: {
      myDrivers: "My Drivers",
      generateVouchers: "Generate Vouchers For Drivers",
      sendVoucher: "Create Voucher",
      printVoucher: "Print Voucher(s)",
      wallet: "Wallet",
      bearer: "Bearer",
      never: "Never",
      sixHours: "6 Hours",
      twelveHours: "12 Hours",
      twentyFourHours: "24 Hours",
      sevenDays: "7 Days",
      thirtyDays: "30 Days",
      addDriver: "Add Driver",
      createDriver: "Create Driver",
      listOfDrivers: "List of Drivers",
      name: "Name",
      phone: "Phone",
      email: "Email",
      state: "State",
      amount: "Amount",
      balanceTo: "Balance To",
      validity: "Validity",
      driversName: "Driver's Name",
      phoneNumber: "Phone Number",
      driversCode: "Driver's Code",
      address: "Address",
      state: "State",
      confirmDelete: "Are you sure you want to delete the driver?",
      successfullyRemoved: "Successfully removed driver",
      amountMissing: "Please input an amount",
      balanceToMissing: "Please select balance destination",
      validityMissing: "Please select an expiry option",
      successfullySent: "Voucher Sent Successfully",
      createVehicleVoucher: "Voucher Created Successfully",
      amountZeroError: "Amount cannot be zero",
      noDriverError: "Select at least one(1) driver to continue",
      nameMissing: "Please input a name",
      codeMissing: "Please input a code",
      addressMissing: "Please input an address",
      stateMissing: "Please input a state",
      successfullyAdded: "Successfully Added Driver",
      linkedVehicles: "Linked Vehicles",
      date: "Date",
      accountType: "Account Type",
      customer: "Customer",
      currency: "Currency",
      naira: "Naira",
      voucherAmount: "Voucher Amount",
      returnBalanceTo: "Return Balance To",
      validity: "Validity",
      driversListGVoucher: "List of Drivers For Generated Voucher",
      drvsName: "Name",
      drvsPhone: "Phone Number",
      drvsEmail: "Email",
      drvsState: "State",
    },

    branch: {
      branchExpenses: "Branches Expenses",
      filterData:
        "You can filter data based on a selected station and region here.",
      name: "Name",
      dealer: "Dealer",
      city: "City",
      selectRegion: "Select region",
      allRegion: "All regions",
      selectBranch: "Select Branch",
      allBranches: "All Branches",
      totalBranches: "Total Branches",
      station: "Station",
      region: "Region",
      expense: "Expense(NGN)",
      category: "Expense by categories",
      allCategory: "All categories",
      totalExpenses: "Total Expenses",
      expenseBreakdown: "Expense Breakdown for",
      date: "Date",
      retailOutlet: "Retail Outlet",
      cat: "Category",
      desc: "Description",
      manageRetail: "Manage Retail Outlets",
      viewRetailOutlet:
        "You can view and manage all your retail outlets here...",
      totalOutlets: "Total Outlets",
      dealerPriceUpdate: "Dealer Price Update",
      dailyBranchTransaction: "Daily station transactions",
      dailyBranchTransOn: "Daily station transactions on",
      viewTransactions: "You can view daily station transactions here...",
      branchTransactionOn: "Daily Station Transaction On",
      product: "Product",
      transactionCount: "Transaction Count",
      status: "Status",
      address: "Address",
      state: "State",
      dealerBranchesReport: "Dealers Branches Report",
      sendBranchesReport:
        "You can send and forward your branches report here...",
      all: "All",
      sent: "Sent",
      notSent: "Not Sent",
      totalCount: "Total count",
      sendDealerReport: "Send Dealer report",
      group: "Group",
      showAll: "Show All",
      selectStatus: "Select Status",
      approved: "Approved",
      declined: "Declined",
      totalTransactions: "Total Transactions",
      successfulTransactions: "Successful Transactions",
      failedTransactions: "Failed Transactions",
      totalCashback: "Total Cashback Charges",
      posTrans: "POS transactions between",
      and: "and",
      transDate: "Transaction Date",
      pump: "Pump",
      amount: "Amount",
      rrn: "RRN",
      maskedPan: "Masked Pan",
      action: "Action",
      assignPos:
        "You can assign and re-assign POS to a selcted station here :)",
      hi: "Hi,",
      allTerminals: "All Terminals",
      terminalId: "Terminal Id",
      serialNo: "Serial No",
      vendor: "Vendor",
      companyBranchesReport: "Company branches report",
      sendCompanyReport: "Send ompany report",
      company: "Company",
      report: "Report",
      reportDate: "Report date",
      atgOnly: "With ATG only",
      true: "True",
      false: "False",
      forwardReport: "Forward report",
      mailTo: "Mail to",
      title: "Retail Outlets",
      details: "Details",
      mailRecipient: "Mail Recipient",
      manageTargets: "Manage Targets",
      mapUserToBranch: "Map User To Retail Outlet",
      branchProduct: "Station products stock",
      selectBranch:
        "select a station to see the corresponding products stock for that here",
      totalStock: "Total stock",
      totalQuantitySupplied: "Total Quantity supplied",
      totalQuantitySold: "Total Quantity sold",
      productName: "Product Name",
      quantitySupplied: "Quantity supplied",
      quantitySold: "Quantity Sold",
      action: "Action",
      stan: "Stan",
    },

    // Customer Balance
    balance: {
      title: "Balance",
      fundWallet: "Fund Wallet",
      history: "History",
      last10Trans: "Last 10 Transactions",
      date: "Date",
      status: "Status",
      amount: "Amount",
      remark: "Remark",
      currentBalance: "Current Balance",
      paymentConfirmation: "Payment Confirmation",
    },
    // shutdown History
    shutdownHistory: {
      pumpShutdown: "Pump shutdown",
      shutdownHistory: "Shutdown history",
      shutdownPumps: "Shutdown pumps",
      shutdownNow: "Shutdown Now",
      scheduleShutdown: "Schedule Shutdown",
      all: "All",
      noShutdownHistory: "No shutdown history recorded for this dealer yet",
      reason: "Reason",
    },
    // Previous Wallet Transactions
    previousTrans: {
      balance: "Balance",
      transBetween: "Transaction between",
      prevTransBtw: "Previous Wallet Transactions between",
      date: "Date",
      status: "Status",
      amount: "Amount",
      remark: "Remark",
      currentBalance: "Current Balance",
    },
    // Fuel Consumption index.uve and vehicle_fuel_consumption.vue
    fuelConsumption: {
      table: "Table",
      chart: "Chart",
      title: "Fuel Consumption",
      plateNumber: "Plate Number",
      date: "Date",
      email: "Email",
      state: "State",
      week: "Week",
      chargeType: "Charge Type",
      driver: "Driver",
      createdBy: "Created By",
      volume: "Volume",
      pricePerLitre: "Price/Litre",
      voucher: "Voucher",
      stationName: "Station Name",
      fuelConsumptionStats: "Fuel Consumption Statistics",
      totalVolume: "Total Volume (Litres)",
      chargeAmount: "Charge Amount",
      description: "Description",
      currentBalance: "Current Balance",
      voucherPin: "Voucher Pin",
      voucherUsed: "Voucher Used",
      voucherAmount: "Voucher Amount",
      parentVoucher: "Parent Voucher",
      amountPaid: "Amount Paid",
      stationState: "Station State",
    },

    // Lease
    lease: {
      leases: "Rents for",
      outlet: "outlet",
      viewEbenLease: "View all rents for Eben station here...",
      allLeases: "All Rents",
      rentDate: "Rent date",
      branchSpace: "Station space",
      occupantName: "Occupant Name",
      occupantEmail: "Occupant Email",
      paymentCompleted: "Payment completed",
      manageBranchSpace: "Manage station space",
      manageBranchSpaceHere:
        "Manage your station space here for your branches here...",
      createBranchSpace: "Create station space",
      totalCount: "Total count",
      rentFree: "Rent free",
      rooms: "Rooms",
      rentDuration: "Rent duration",
      available: "Available",
      action: "Action",
      propertyName: "Property name",
      rentFee: "Rent fee",
      numberOfRooms: "Number of rooms",
      numberOfRestrooms: "Number of rest rooms",
      additionalDetails: "Additional details",
      branchLease: "Station Rents",
      viewBranchLease: "View all station rent by selecting a station here...",
      allLeases: "All Rents",
      selectBranch: "select branch",
      leasedBy: "Rented by",
    },
    // Customer Fund Wallet
    fundWallet: {
      confirmingPayment: "Confirming your payment...",
      paymentconfirmed: "Payment Confirmed",
      errorConfirming: "Error Confirming your payment, please try again.",
      bankTransfer: "Bank Transfer",
      fundWithCard: "Fund with Card",
      fundAccountWithCard: "Fund your Account by paying with your card online",
      howMuch: "How much would you like to fund your wallet with?",
      payNow: "Pay Now",
      fundAccountWithBank:
        "Fund your account by doing a bank transfer to the following bank details",
      accountName: "Account Name",
      amount: "Amount",
      remis: "Remis",
      bankName: "Bank Name",
      accountNumber: "Account Number",
      processingFunding:
        "Your Wallet would be funded within the next few minutes.",
      paymentConfirmed: "Payment Confirmed!",
      paymentCompleted: "Payment Completed",
      amountNotSet: "Please input an amount",
    },
    // Outstanding Payments indev.vue and outstanding_payments.vue
    payments: {
      totalAmount: "Total Amount",
      title: "Outstanding Payments",
      makePayments: "Make Payments",
      branchName: "Station Name",
      address: "Address",
      accountName: "Account Name",
      accountNumber: "Account No.",
      bankName: "Bank Name",
      amount: "Amount",
      updateAccount: "Update Account",
      viewTransactions: "View Transactions",
      processingPayments: "Processing Payment",
      amountToTransfer: "Amount To Transfer",
      inputAmount: "Input Amount",
      noAccountError: "Please select at least one account to make payment to",
      amountMissing: "Please input an amount for",
      amountLow: "Please input an amount greater than 0 for",
      successfulPayment: "Successfully Made Payment!",
    },
    // Wallet Transactions
    cusWalletTransactions: {
      totalTransactions: "Total Transactions",
      title: "Wallet Transactions",
      transBetween: "Wallet Transactions between",
      date: "Date/Time",
      amount: "Amount {currency}",
      source: "Source",
      status: "Status",
      walletBalance: "Wallet Balance {currency}",
    },
    // Customer Profile
    cusProfile: {
      accountSettings: "Account Settings",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      editProfile: "Edit Profile",
      changeYourPassword: "Change Your Password",
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      changePassword: "Change Password",
      successfullyChanged: "Successfully changed Password!",
      fillIn: "Fill in the missing Fields",
      updated: "Profile updated successfully!",
      oldPasswordMissing: "Please input your current password",
      passwordBlank: "Password field cannot be blank",
      passwordsDontMatch: "Passwords don't match",
      newPasswordMissing: "Please input your new password",
      newPasswordShort: "New password should be between 8 and 100 characters",
      confirmPasswordError: "Please confirm your new password",
      passwordLackingError:
        "New password should include at least one alphanumeric character and one special character",
    },
    // Customer Retainership
    cusRetainership: {
      title: "Retainerships | RETAINERSHIP",
      balance: "Balance",
      company: "Company",
      wallet: "Wallet",
    },
    // Send Voucher
    sendVoucher: {
      sendVoucherBy: "Send Voucher By",
      voucherPin: "Voucher Pin",
      voucherAmount: "Voucher Amount",
      recipientEmail: "Recipient Email",
      recipientPhone: "Recipient Phone Number",
      message: "Message",
      sendSms: "Send SMS",
      sendMail: "Send Mail",
      messageError: "Please input a message",
      emailBlank: "Please input the recipient's email",
      phoneNoBlank: "Please input recipient's phone number",
      shortNo:
        "Recipient's Phone Number should be between 10 and 13 characters",
      successfullySent: "Voucher Sent Successfully",
    },
    // Sub Accounts
    subAccounts: {
      title: "Sub-Accounts",
      createSubAccount: "Create Sub-Account",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      balance: "Balance",
      details: "Details",
      successfullyDeleted: "Successfully deleted Sub-Account",
      confirmDelete: "Are you sure you want to delete the this Sub Account?",
    },
    // Create Sub Account
    createSubAccount: {
      addSubAccount: "Add Sub-Account",
      fillFields: "Fill in the fields",
      email: "email@email.com",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      successfullyCreated: "Successfully created Sub-Account",
    },
    // Sub Account Details
    subAccountDetails: {
      title: "Sub Account",
      vouchers: "Vouchers",
      transactions: "Transactions",
      consumptions: "Consumptions",
      consumptionRecords: "Consumption Records",
      transBetween: "Transactions between",
      date: "Date",
      volume: "Volume",
      pricePerLitre: "Price/Litre",
      voucherAmount: "Voucher Amount",
      voucher: "Voucher",
      amountPaid: "Amount Paid",
      stationName: "Station Name",
      city: "City",
      state: "State",
      status: "Status",
      amount: "Amount",
      remark: "Remark",
      currentBalance: "Current Balance",
      dateCreated: "Date Created",
      returnBalanceTo: "Return Balance To",
      isUsed: "Is Used",
      source: "Source",
      expiryDate: "Expiry Date",
    },
    // Vehicles
    vehicles: {
      myVehicles: "My Vehicles",
      generateVouchers: "Generate Vouchers for Vehicles",
      sendVoucher: "Create",
      wallet: "Wallet",
      bearer: "Bearer",
      never: "Never",
      sixHours: "6 Hours",
      twelveHours: "12 Hours",
      twentyFourHours: "24 Hours",
      sevenDays: "7 Days",
      thirtyDays: "30 Days",
      never: "Never",
      all: "All",
      selectVehicle: "Select Vehicle(s)",
      used: "Can be Used In",
      listOfVehicles: "List of Vehicles",
      printVoucher: "Print Voucher(s)",
      driver: "Driver",
      vehicleType: "Vehicle Type",
      carMake: "Car Make",
      allVehicles: "All Vehicles",
      errorOccured: "An Error Occured",
      carModel: "Car Model",
      modelYear: "Model Year",
      plateNumber: "Plate Number",
      cardNumber: "Card Number",
      amount: "Amount",
      networkError: "Network Error, Please Check Your Internet connection",
      balanceTo: "Balance To",
      validity: "Validity",
      canBeUsedIn: "Can be used in",
      phoneNumber: "Phone Number",
      amountMissing: "Please input an amount",
      balanceToMissing: "Please select balance destination",
      validityMissing: "Please select an expiry option",
      usedInMissing: "Please select where this voucher can be used",
      successfullySent: "Voucher Sent Successfully",
      amountZeroError: "Amount cannot be zero",
      noVehicleError: "Please select at least one(1) vehicle to continue",
      fuelConsumed: "Fuel Consumed",
      vehicleType: "Vehicle Type",
      vehicleMake: "Vehicle Make",
      vehicleModel: "Vehicle Model",
      generateVehicleVoucher: "Generate Vehicle Voucher",
      createVoucher: "Create Voucher",
      enterDetails: "Enter Voucher Details",
      year: "Year",
      returnBalance: "Return Balance To",
    },
    // Create Vehicle
    createVehicle: {
      title: "Create Vehicle",
      enterVehicleDetails: "Enter Vehicle Details",
      selectVehicleType: "Select Vehicle Type",
      carOrLorry: "Car/Lorry",
      motorcycle: "Motorcycle",
      selectVehicleMake: "Select Vehicle Make",
      selectVehicleModel: "Select Vehicle Model",
      title: "Create Vehicle",
      plateNumberPlaceholder: "Plate Number",
      fullName: "Full Name",
      phoneNumber: "Phone Number",
      modelYear: "Model Year",
      plateNumberMissing: "Please input car's plate number",
      fullNameMissing: "Please enter car owner's full name",
      vehicleTypeMissing: "Please select vehicle type",
      carMakeMissing: "Please select vehicle make",
      carModelMissing: "Please select vehicle model",
      modelYearMissing: "Please input vehicle model year",
      successfullyCreated: "Successfully Created Vehicle",
    },
    // Verify Receipt
    verifyReceipt: {
      title: "VERIFY RECEIPT",
      verify: "VERIFY",
      amount: "Amount",
    },
    // Voucher
    voucher: {
      generated: "Vouchers",
      transferred: "Transferred",
      expired: "Expired",
      transBetween: "Transactions between",
      sendByMail: "Send by Mail",
      sendBySms: "Send by SMS",
      listOfVouchers: "List of Vouchers",
      printVoucher: "Print Voucher(s)",
      title: "Voucher",
      dateCreated: "Date Created",
      amount: "Amount",
      returnBalanceTo: "Return Balance To",
      isUsed: "Is Used",
      source: "Source",
      expiryDate: "Expiry Date",
      dateSent: "Date Sent",
      bearer: "Bearer",
      sentVia: "Sent Via",
      successfullyPrinted: "Successfully Printed Vouchers",
      selectAtLeast: "Select at least one(1) voucher to continue",
    },
    // Create Voucher
    createVoucher: {
      createNew: "Create New Voucher",
      completeAtLeast:
        "Please complete at least one voucher to proceed, click the add  more button to add new voucher",
      amount: "Amount",
      byHowMany: "By How Many",
      date: "Date",
      returnBalanceTo: "Return Balance To",
      accountType: "Account Type",
      expiry: "Expiry",
      canBeUsedIn: "Can Be Used In",
      voucherAmount: "Voucher Amount",
      validity: "Validity",
      bearer: "Bearer",
      wallet: "Wallet",
      never: "Never",
      sixHours: "6 Hours",
      twelveHours: "12 Hours",
      twentyFourHours: "24 Hours",
      sevenDays: "7 Days",
      thirtyDays: "30 Days",
      all: "All",
      naira: "Naira",
      currency: "Currency",
      customer: "Customer",
      addMore: "Add More",
      serviceCharge: "Each Voucher attracts a service charge of {currency}",
      list: "List Of Vehicles For Generated Voucher",
      title: "Create Voucher",
      amountInvalid: "Please input a valid amount",
      lowVouchers: "Number of vouchers to be generated cannot be less than 1",
      amountMissing: "Please input an amount",
      vouchersNumberBlank:
        "Numbers of vouchers to be generated field cannot be blank",
      successfullyCreated: "Successfully Created Voucher",
    },
    // Account Confirmation
    accountConfirmation: {
      accountConfirmed: "Account Confirmed",
      thankYou: "Thank you for confirming your email.",
      confirmed:
        "You can now login to enjoy the benefits that Epump has to offer.",
      inProcess: "Email confirmation in process",
      login: "Login",
      emailConfirmation: "Email Confirmation",
      pleaseWait: "Please wait while",
      weConfirm: "we confirm your email",
      proceed: "Proceed to login after",
      afterSuccessfulConfirmation: "Email has been successfully confirmed.",
      accountConfirm: "Account Confirmed",
      emailAddress: "Email Address",
      sign: "Sign In",
      signIn: "Sign In | SIGN IN",
      email: "Email",
      password: "Password",
      passwordLackingError:
        "Password should include at least one alphanumeric character and one special character",
      thanksForConfirming: "Thanks for confirming your email, proceed to login",
      loginSuccessful: "Login Successful",
      fillIn: "Fill in the missing fields",
      noAccount: "Don't have an account?",
      signUp: "Sign Up",
      noAccess:
        "You do not have any of the required roles to access the portal",
    },
    // Change Password
    changePassword: {
      changeYourPassword: "Change Your Password",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      title: "Change Password",
      enterDetails:
        "Enter the details of your old password and your new password",
      toReset: "To reset your password",
      inProcess: "Email confirmation in process",
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      oldPasswordMissing: "Please input your current password",
      newPasswordMissing: "Please input your new password",
      passwordLackingError:
        "New password should include at least one alphanumeric character and one special character",
      newPasswordShort: "New password should be between 8 and 100 characters",
      passwordsDontMatch: "Passwords don't match",
      successfullyChanged: "Successfully changed password",
      confirmPasswordError: "Please confirm your password",
    },
    // Password Email Notifiaction
    passwordEmailNotification: {
      passwordReset: "Password Reset",
      linkSent: "A password reset link has been",
      sentToMail: "sent to your mail",
      pleaseCheck: "Please check your mail and click the reset",
      toReset: "link to reset your password.",
      backToLogin: "Back to Login",
    },
    // Password Reset Confirmation
    passwordResetConfirmation: {
      resetYourPassword: "Reset your Password",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      resetPassword: "Reset Password",
      enterDetails:
        "Enter the details of your old password and your new password",
      toReset: "to reset your password",
      pleaseWait: "Please wait while we complete your password request!",
      email: "Email",
      emailAddress: "Email Address",
      password: "New Password",
      confirmPassword: "Confirm New Password",
      confirmPasswordError: "Please confirm your password",
      passwordLackingError:
        "Password should include at least one alphanumeric character and one special character",
      passwordsDontMatch: "Passwords don't match",
      resetCompleted: "Password Reset completed, proceed to login",
      fillIn: "Fill in the missing fields",
    },
    // Registration Completed
    registrationCompleted: {
      title: "Registration Completed",
      linkSent: "A confirmation link has been",
      sentToMail: "sent to your mail",
      pleaseCheck: "Please check your mail and click the confirmation",
      toConfirm: "link to confirm your email address.",
      backToLogin: "Back to Login",
    },
    // signUp
    signUp: {
      signUp: "Sign UP",
      firstName: "First Name",
      lastName: "Last Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      password: "Password",
      register: "Register",
      existingAccount: "Already have an account?",
      signIn: "Sign In",
      manageFueling: "Manage your day to day Fueling with Epump",
      register: "Register",
    },
    // Reset Password
    resetPassword: {
      resetYourPassword: "Reset Your Password",
      title: "Reset Password",
      enterUserName: "Enter your email address in the field in the left",
      sectionReset: "section to reset your password",
      inProcess: "Email confirmation in process",
      userName: "Username",
      email: "Email",
      linkSent:
        "A Password Reset link has been sent to your email, click on it to complete password reset",
      userNameMissing: "Please input a username",
    },
    // Login
    login: {
      selectALanguage: "Select a language",
      selectACountry: "Select a country",
      signIn: "Sign In | SIGN IN",
      noAccount: "Don't have an account?",
      signUp: "Sign up | SIGN UP",
      forgotPassword: "Forgot Password?",
      hello: "Hello",
      user: "User!",
      keepConnected: "To keep connected with us please",
      loginWith: "login with your Account info",
      or: "OR",
      enterDetails: "Enter your personal details and start",
      yourJourney: "your journey with us",
      createAccount: "Create Account | CREATE ACCOUNT",
      passwordMustContain: "Password Must Contain",
      oneNumeric: "One Numeric Character",
      specialCharacter: "One Special Character",
      haveAnAccount: "Have an account?",
      email: "Email",
      emailAddress: "Email Address",
      password: "Password",
      phoneNumber: "Phone Number",
      firstName: "First Name",
      lastName: "Last Name",
      confirmPassword: "Confirm Password",
      passwordLackingError:
        "Password should include at least one alphanumeric character and one special character",
      successfullySignedUp:
        "You have successfully signed up. Please check your mail for a confirmation link",
      loginSuccessful: "Login Successful",
      confirmPasswordError: "Please confirm your new password",
      passwordsDontMatch: "Passwords don't match",
      forgotPassword: "Forgot Password ?",
      manageFuelingEpump: "Manage your day to day fueling with epump",
      resetPassword: "ResetPassword",
    },
    /***** Modals */

    // Add Email To Branch
    addEmailToBranch: {
      mapUser: "Map User To Retail Outlet",
      companyAdmin: "Company Admin",
      branchManager: "Station Manager",
      customer: "Customer",
      email: "Email",
      selectRole: "Select Role",
      selectRoleError: "Please select a role",
      successfullyMapped: "Successfully mapped user to Retail Outlet",
    },
    // aaDetails Modal
    aaDetailsModal: {
      companyAddres: "Company Address",
      companyName: "Company Name",
      orderNumber: "Order Number",
      refNumber: "Reference Number",
      unregisteredTruck: "Unregistered Truck",
      driverName: "Driver name",
      driverEmail: "Driver Email",
      driverPhone: "Driver Phone",
      licensePlate: "License Plate",
      waybillDate: "Waybill Date",
      comment: "Comment",
      truckName: "Truck Name",
    },
    // Add AAModals
    addAAModal: {
      addAA: "Add Alarm and Alert",
      selectOwner: "Select Owner",
      selectEvent: "Select Event",
      addAlertAlarm: "Add AlertAlarm",
      chooseOwner: "Please choose an Owner",
      chooseEvent: "Please choose an Event",
      aaAdded: "Successfully added AA",
    },
    // Update AAModal
    updateAAModal: {
      updateAA: "Update Alarm and Alert",
      update: "Update",
    },
    // Assets
    assets: {
      inflow: "Inflow",
      outflow: "Outflow",
      updateCreditLimit: "Update credit limit",
      walletTransactions: "Wallet transaction",
      addAssetFile: "Add Files to Asset",
      documents: "Documents",
      uploadDoc: "Upload documents",
      successfullyAddedAssetFile: "Successfully Added asset file",
      selectDoc: "Please select a document",
      // Add assets to group
      assetName: "Asset Name",
      assetDescription: "Asset Description",
      assetGroup: "Asset Group",
      selectGroup: "Select group",
      assetLicenseNo: "Asset License Number",
      isServicable: "Is Servicable?",
      isRenewable: "Is Renewable?",
      serviceDate: "Service Date",
      renewalDate: "Renewal date",
      expiryDate: "Expiry Date",
      createAsset: "Create Asset",
      assetNameRequired: "Asset Name is required",
      assetDescRequired: "Asset Description is required",
      selectServiceDate: "Please select a service date",
      selectRenewalDate: "Please select a renewal date",
      sucessfullyRenewedAsset: "Successfully renewed asset",
      successfullyCreatedAsset: "Successfully created asset",
      successfullyCreatedAssetGroup: "Successfully created asset group",
      successfullyUpdatedAsset: "Successfully updated asset",
      // Asset details
      assetN: "Asset Name:",
      assetGName: "Asset Group Name:",
      assetDescription: "Asset Desc",
      assetStatus: "Asset Status:",
      assetDetail: "Asset Details",
      licenseNumber: "License Number:",
      currActive: "Currently Active:",
      servDate: "Service Date:",
      nextRenewalDate: "Next Renewal Date:",
      lastRenewalDate: "Last Renewal Date:",
      expirationDate: "Expiration Date:",
      dateCreated: "Date Created:",
      // Create Asset Group
      createAssetGroup: "Create Asset Group",
      groupName: "Group Name",
      groupDesc: "Group Description",
      groupType: "Group Type",
      selectGroupType: "Select Group Type",
      licensesPermits: "Licenses and Permits",
      physical: "Physical",
      inputGroupName: "Please input a group name",
      inputDesc: "Please input a description",
      selectGroupType: "Please select a group type",
      successfullyEditedAssetGroup: "Successfully edited asset group",
      downloadSuccessful: "Download Successful",
      fileDeleted: "Succesfully deleted file",
    },
    // Edit asset
    editAsset: {
      editAsset: "Edit Asset",
      assetName: "Asset Name",
      assetDescription: "Asset Description",
      save: "Save",
      assetGroup: "AssetGroup",
      // Edit asset Group
      editAssetGroup: "Edit Asset Group",
    },
    // Record Service
    recordService: {
      recordService: "Record Service",
      dateServiced: "Date Serviced",
      nextServiceDate: "Next Service Date",
      note: "Note",
      chooseServiceDate: "Please choose the service date",
      chooseNextServiceDate: "Please choose a next service date",
      serviceRecorded: "Successfully recorded service",
    },
    // Company Domain
    companyDomain: {
      updateCompanyDomain: "Update Company Domain",
      update: "Update",
      title: "Company Domain",
      domainMissing: "Please input a Company Domain",
      successfullyUpdated: "Successfully Updated Company Domain",
    },
    // Add Truck Modal
    addTruckModal: {
      addTruck: "Add Truck",
      selectCompanyProduct: "Select Company Product",
      dpk: "DPK",
      ago: "AGO",
      pms: "PMS",
      vehicleType: "Vehicle Type (0 or 1)",
      zero: "0",
      one: "1",
      productionDate: "Production Date",
      engineNumberRequired: "Engine Number is required",
      brandRequired: "Brand is required",
      licensePlateMissing: "License Plate Missing",
      vinMissing: "VIN Missing",
      companyProductRequired: "Company Product is Required",
      vehicleTypeRequired: "Vehicle Type is Required",
      successMsg: "Truck successfully Added",
      vin: "VIN",
      firstName: "Driver First Name",
      lastName: "Driver Last Name",
      driverEmail: "Driver Email",
      totalFTVol: "Total Fuel Tank Volume",
      model: "Model",
      unitId: "Unit ID",
      color: "Color",
    },
    // Truck Details
    truckDetailsModal: {
      truckDetailsFor: "Truck Details For",
      licensePlate: "License Plate",
      brand: "Brand",
      vehicleName: "Vehicle Name",
      companyProduct: "Company Product",
      engineNumber: "Engine Number",
      chasisNumber: "Chasis Number",
      type: "Type",
      totalTankVol: "Total Tank Vol",
    },
    // Update Truck modal
    updateTruckModal: {
      updateTruck: "Update Truck",
      updateTruckFor: "Update Truck for",
      model: "Model",
      fuelTankVol: "FuelTank Vol",
      engineNo: "Engine No",
      chasisNo: "Chasis No",
      vehicleTyp: "Vehicle Type",
      select: "0 or 1",
      successMsg: "Truck successfully Updated",
    },
    // Dashboard Modal
    dModal: {
      dearCustomer: "Dear Customer,",
      accessDisabled:
        "Your epump subscription has expired, and your access to the portal has been disabled. Kindly make payment to reactivate your access to the portal. Thank you.",
      viewInvoices: "View Invoices",
      subscriptionExpire: "Your epump subscription will expire in",
      serviceDisabled:
        "Your service will be disabled if you fail to make payment before the due date. Thank you.",
      continueToPortal: "Continue To Portal",
      trackHistory: "Track History",
    },
    // Detail Action Modal
    detailAction: {
      detailsFor: "Details for",
      dueDate: "Due Date",
      facilityType: "Facility Type",
      facilityName: "Facility Name",
      status: "Status",
      countDown: "CountDown",
      update: "Update",
      done: "Mark as Done",
      maintenanceTrackDetails: "Maintenance Track Details",
      description: "Description",
      name: "Name",
      email: "Email",
    },
    // Invoices
    invoicesModal: {
      export: "Export to PDF",
      pdfInvoice: "Your invoice is ready to be downloaded as a PDF.",
      cancel: "Cancel",
      downloadPdf: "Download PDF",
      successMsg: "Download Successful",
      errorMsg: "Unable to download file",
      // Wallet Pay modal
      walletPay: "Pay From Wallet",
      enoughFundsInCompany: "You have enough funds in your company wallet",
      walletBal: "Wallet Balance:",
      amountDue: "Amount Due:",
      pay: "PAY",
      paymentSuccessful: "Invoice Payment Successful",
    },

    // Drivers Modal
    driverModal: {
      assignDriver: "Assign Driver to A Truck",
      selectCompanyTruck: "Select Company Truck",
      assignTruck: "ASSIGN TRUCK",
      successMsg: "Successfully Assigned",
      errorMsg: "Truck Not Selected",
      linkVehicle: "Link Vehicle",
    },

    // Dry Stock
    dryStockModal: {
      rejectionReason: "Reason for rejection",
      rejectSupply: "Reject supply",
      successMsg: "Successfully rejected supply",
    },

    // Add Driver Modal
    addDriverModal: {
      title: "Add Driver",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phoneNumber: "Phone No.",
      successfullyAdded: "Successfully Added Driver",
    },
    // Group management modal
    gManagement: {
      addCompanyGroup: "Add Company Group",
      addIndustryGroup: "Add Industry Group",
      selectCategory: "Select Category",
      addGroup: "Add Group",
      inputName: "Please input a name",
      inputEmail: "Please input an Email",
      inputDesc: "Please input a description",
      chooseCategory: "Please choose a Category",
      groupCreated: "Successfully created Group",
      mapGroupToBranch: "Map Group To Branch",
      mapGroupToSite: "Map Group To Site",
      selectIndustryBranch: "Select Industry Branch",
      selectCompanyBranch: "Select Company Branch",
      mapGroup: "Map Group",
      noBranchCreated: "There is no station created by this company",
      errorMsg: "Station Not Selected",
      successMsg: "Successfully Mapped Group",
      updateCompanyGroup: "Update Company Group",
      updateIndustryGroup: "Update Industry Group",
      updatedGroup: "Successfully updated Group",
    },

    // Edit Driver Modal
    editDriverModal: {
      title: "Edit Driver",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phoneNumber: "Phone No.",
      successfullyEdited: "Successfully Edited Driver",
    },
    // Mange Expenses - Edit Category
    editCategoryModal: {
      title: "Edit Category",
      category: "CATEGORY",
      categoryPlaceholder: "Input Category",
      categoryMissing: "Please input a category",
      successfullyEdited: "Successfully edited Category",
      unsuccessfulEdit: "Unable to Edit Category",
      sameCategoryError:
        "Please input a different category from the current one",
    },
    // Order - Update Order Status
    updateOrderStatusModal: {
      setStatus: "Set Order Status",
      comment: "Comment",
      orderStatus: "Order Status",
      driverAssigned: "Driver Assigned",
      paymentPending: "Payment Pending",
      paymentCompleted: "Payment Completed",
      paymentConfirmed: "Payment Confirmed",
      orderCompleted: "Order Completed",
      orderAccepted: "Order Accepted",
      orderRejected: "Order Rejected",
      processing: "Processing",
      inTransit: "In Transit",
      arrived: "Arrived",
      ownerAccepted: "Owner Accepted",
      fillStarted: "Fill Started",
      fillEnded: "Fill Ended",
      title: "Update Status",
      commentMissing: "Please input a comment",
      successfullyUpdated: "Successfully updated order status",
    },
    // Outstanding Payments - Edit Account Details Modal
    editAccountDetailsModal: {
      updateDetails: "Update Account Details",
      accountNumber: "Account Number",
      bankName: "Bank Name",
      selectBank: "Select a bank",
      accountName: "Account Name",
      accountBalance: "Account Balance",
      title: "Update Account",
      verifyAccount: "Verify Account",
      amount: "Amount",
      accountNumberMissing: "Please input an account number for",
      bankMissing: "Please select a bank for",
      successfullyVerified: "Successfully verified account",
      successfullyUpdated: "Successfully Updated Account Details",
    },
    // Product
    editProductModal: {
      title: "Edit Product",
      productName: "Product Name",
      price: "Price",
      state: "State",
      localGov: "Local Government",
      area: "Area | Areas",
      lgaName: "LGA Name",
      deliveryHour: "Delivery Hour",
      addMore: "Add More",
      productNameMissing: "Please input a product name",
      priceMissing: "Please input a price",
      deliveryHourMissing: "Please input a Delivery Hour",
      successfullyEdited: "Successfully Edited Product",
    },
    //  pumps
    editFaultModal: {
      title: "Edit Target",
      updateTarget: "Update Target",
      inputTarget: "Input Target",
      target: "TARGET",
    },

    // Retainership - Edit Credit Limit
    editCreditLimit: {
      title: "Edit Credit Limit",
      edit: "Edit",
      creditLimit: "Credit Limit",
      creditLimitMissing: "Please input a credit limit",
      successfullyEdited: "Successfully Edited Credit Limit",
      unsuccessfulEdit: "Unable to edit Credit Limit",
    },
    // Shifts - Close Shifts
    closeShift: {
      title: "Close Shift",
      description: "DESCRIPTION",
      shiftDescription: "Shift Description",
      closingReading: "Closing Reading | CLOSING READING",
      closingReadingMissing: "Please input a Closing Reading",
      shiftDescriptionMissing: "Please input a shift Description",
      successfullyClosed: "Successfully Closed Shift",
    },
    // Targets - Create Target
    createTargetModal: {
      title: "Create Target",
      monthlyTarget: "Retail Outlet Daily Sales Target",
      salesProduct: "SALES PRODUCT",
      selectAProduct: "Select a product",
      target: "Target | TARGET",
      setTarget: "Set Target",
      setBudget: "Set Budget",
      productMissing: "Please select a product",
      targetMissing: "Please input a target",
      successfullyAdded: "Successfully Added Retail Outlet Target",
      targetExists:
        "This product currently has a target, please edit target to change target",
    },
    // Targets - Edit Target and edit Faults
    editTargetModal: {
      title: "Edit Target",
      monthlyTarget: "Retail Outlet Daily Sales Target",
      salesProduct: "SALES PRODUCT",
      selectAProduct: "Select a product",
      target: "Target | TARGET",
      productMissing: "Please select a product",
      targetMissing: "Please input a target",
      successfullyUpdated: "Successfully Updated Retail Outlet Target",
      unsuccessfulUpdate: "Unable to udpate target",
    },
    // Trucks - Add Truck
    addTruckModal: {
      title: "Add Truck",
      name: "Name",
      plateNumber: "Plate Number",
      tankType: "Tank Type",
      capacity: "Capacity",
      nameMissing: "Plese input a name",
      plateNumberMissing: "Please input a plate number",
      tankTypeMissing: "Please input a tank type",
      capacityMissing: "Please input a capacity",
      lowCapacity: "Please input a capacity greater than 0",
      successfullyAdded: "Successfully Added Truck",
    },
    // Assign Truck Modal
    assignTruckModal: {
      title: "Assign Truck to A Driver",
      selectCompanyDriver: "Select Company Driver",
      assign: "ASSIGN DRIVER",
      driverError: "Driver Not Selected",
      assignSuccess: "Successfully Assigned",
    },
    // Trucks - Edit Truck
    editTruckModal: {
      title: "Edit Truck",
      name: "Name",
      plateNumber: "Plate Number",
      tankType: "Tank Type",
      capacity: "Capacity",
      nameMissing: "Plese input a name",
      plateNumberMissing: "Please input a plate number",
      tankTypeMissing: "Please input a tank type",
      capacityMissing: "Please input a capacity",
      successfullyEdited: "Successfully Edited Truck",
    },
    // Vehicle - Edit Vehicle
    editVehicleModal: {
      title: "Edit Vehicle",
      edit: "Edit",
      driver: "Driver | DRIVER",
      phoneNumber: "Phone Number | PHONE NUMBER",
      vehicleType: "Vehicle Type | VEHICLE TYPE",
      carMake: "Car Make | CAR MAKE",
      carModel: "Car Model | CAR MODEL",
      modelYear: "Model Year | MODEL YEAR",
      plateNumber: "Plate Number | PLATE NUMBER",
      driverMissing: "Please input a driver",
      vehicleTypeMissing: "Plese input a Vehicle Type",
      carMakeMissing: "Please input a Car Make",
      carModelMissing: "Please input a Car Model",
      modelYearMissing: "Please input a Model Year",
      plateNumberMissing: "Please input a Plate Number",
      successfullyEdited: "Successfully Edited Vehicle",
    },
    //Add card to vehicle
    addCardVehicle: {
      title: "Add Card To Vehicle",
      cardNum: "Card Number",
      newPin: "New Pin",
      oldPin: "Old pin",
      pin: "Pin",
      confirmPin: "Confirm Pin",
      addCard: "Add Card",
      cardError: "Please input a card number",
      pinError: "Please input a pin",
      confirmPinError: "Please confirm your pin",
      pinNoMatch: "Pins don't match",
      cardSuccess: "Successfully added card to vehicle",
      oldPinError: "Please input your old pin",
      fourDigitErr: "Please input a pin with 4 digits",
      newPinErr: "Please input a new pin",
      newPinFourErr: "Please input a new pin with 4 digits",
      successfullyChangedPin: "Successfully changed pin",
      sureBlockCard: "Are you sure want to block this card?",
      successfullyBlockedCard: "Successfully blocked card",
    },
    // Add old user modal
    addOldUser: {
      addExistingUser: "Add existing user",
      selectAcessLevel: "select acess level",
      select: "Select",
      addUser: "Add user",
      alreadyMapped:
        "This account has been mapped to a company account already.",
      alreadyMapped2: "therefore,you have access to all station information",
      usedAdded: "User added",
    },
    // Fund SubAccount Modal
    fundSubAccount: {
      title: "Fund Subaccount",
      amtErr: "Amount Field cannot be blank",
      fundSuccess: "Successfully Funded Sub accounts",
    },
    //Generate Deposit Modal
    generateDepositModal: {
      generateDeposit: "Generate deposit",
      selectAccount: "Select account",
      selectBank: "select bank",
      selectDate: "select date",
      ref: "Ref",
      generateReference: "Generate reference",
      desc: "Make payment into any",
      desc1: "bank using PayDirect",
      // desc2: "as the narration on teller",
    },
    // Link bank account modal
    linkBankAccModal: {
      enterfullname: "Enter Fullname",
      back: "Back",
      linkedAccounts: "Linked accounts",
      recommended: "Recommended",
      desc: "With this account",
      desc1: "we confirm your bank deposits to the linked bank accounts",
      proceed: "Yes, proceed",
      nonlinkedAccounts: "Non-linked accounts",
      regAccount: "A regular account that is added for transactions",
      addNewBank: "Add new bank",
      nonlinkedAccounts: "Non-linked accounts",
      nonLinkedDesc: "Fill the form below to add a non-linked account",
      accountName: "Account name",
      accountNumber: "Account number",
      bank: "Bank",
      compNoBankAcc: "Your company currently doesn't have any bank accounts",
      accWillBeDisplayed: "Bank accounts will be displayed when added",
      noBankrecords: "No bank records",
      addNewBank: "Add new bank",
      accNoErr: "Account number should be 10 characters",
      linkAccSuccess: "Successfully linked bank account",
    },
    //Map to dealer modal
    mapToDealerModal: {
      title: "Map Company To Dealer",
      dealersEmail: "Dealer's Email",
      mapToDealer: "Map To Dealer",
      mtdSuccess: "Dealer Successfully Mapped",
    },
    // Max cash amount
    maxCashAmtModal: {
      title: "Maximum Cash Amount",
      inputAmount: "input amount",
      updateAmt: "Update Amount",
      amtErr: "Amount is required",
      inputDiffErr: "Please input a different amount from the current one",
      inputGreaterPrev: "Please input an amount greater than 0",
      successfullyUpdatedCIR: "Successfully updated cash insurance ratio",
    },
    // Success signup modal
    successSUmodal: {
      desc: "You have successfully signed up",
      desc1: "An account confirmation link has been sent to your email address",
    },
    // Variance reject modal
    varRejectModal: {
      varianceReject: "Variance Reject",
      groupName: "Group Name",
      groupDescription: "Group Description",
      groupType: "Group type",
      selectGroupType: "Select Group Type",
      licencesAndPermits: "Licences and Permits",
      Physical: "Physical",
      createAssetGroup: "Create Asset group",
      grpNameErr: "Please input a group name",
      descErr: "Please input a description",
      groupTypeErr: "Please select a group type",
      successfullyCreatedAG: "Successfully created asset group",
    },
    //Waybill Modals
    waybillModal: {
      add: "Add Waybill",
      wbDate: "Waybill Date",
      refNumber: "Reference Number",
      volume: "Volume",
      orderNo: "Order Number",
      useComTruck: "Use Company Truck",
      selComTruck: "Select Company Truck",
      unregTruckDes: "Unregistered Truck Description",
      selectCompanyPro: "Select Company Product",
      comment: "comment",
      dateErr: "Date is required",
      refnoErr: "Reference Number is required",
      volErr: "Volume Missing",
      orderNoErr: "Order Number Missing",
      successfullyAddedWb: "Waybill successfully Added",
      updateWbFor: "Update Waybill for",
      updateWb: "Update Waybill",
      wbUpdateSuccess: "Waybill successfully Updated",
      wbDetFor: "Waybill Details for",
      companyName: "Company Name",
      companyAddress: "Company Address",
      productName: "Product Name",
      unregisteredTruck: "Unregistered Truck",
      driverName: "Driver Name",
      driverEmail: "Driver Email",
      driverPhone: "Driver Phone",
      truckName: "Truck Name",
      licensePlate: "License Plate",
      waybillDate: "Waybill Date",
    },
    // Zone - Edit Zone
    editZone: {
      title: "Edit Zone",
      zone: "Zone | ZONE",
      zoneMissing: "Please input a zone",
      successfullyEdited: "Successfully edited zone",
      unsuccessfulEdit: "Unable to edit zone",
    },
    // Retainership - Add New Retainerhip
    addNewRetainership: {
      title: "Add New Retainership",
      firstName: "First Name*",
      lastName: "Last Name*",
      email: "Email*",
      phoneNumber: "Phone Number*",
      password: "Password*",
      confirmPassword: "Confirm Password*",
      openingBalance: "Opening Balance",
      add: "Add",
      successfullyAdded: "Successfully Added Retainership",
      confirmPasswordMissing: "Please confirm your password",
      passwordsDontMatch: "Passwords don't match",
    },
    // Retainership - Add Existing
    addExisting: {
      title: "Add Existing",
      email: "Email",
      add: "Add",
      successfullyAdded: "Successfully Added Retainership",
    },
    // Fund Wallet Modal
    fundWalletModal: {
      confirmingPayment: "Confirming your payment...",
      paymentconfirmed: "Payment Confirmed",
      errorConfirming: "Error Confirming your payment, please try again.",
      payOnline: "Pay Online",
      fundWith: "Fund your Wallet with?",
      fundViaBank: "Fund Via Bank",
      payNow: "Pay Now",
    },
    // Payment Confirmation
    paymentConfirmation: {
      openModal: "Open Modal",
    },

    //partner modals
    //mapPartnerToStation modal
    mapPartnerToBranch: {
      title: "Map partner to branch",
      selectBranch: "Select branch",
    },

    //mapUserToPartner modal
    mapUserToPartner: {
      title: "Map user to partner",
      enterEmail: "Enter email",
      mapUser: "Map user",
      removePartner: "Remove partner from user",
    },

    //removeUserFromPartner modal
    removeUserFromPartnerModal: {
      unMapUsers: "Unmap user from partner",
      enterEmail: "Enter email",
    },

    // pos Modals
    posModal: {
      branchName: "Station Name:",
      transactionType: "Transaction Type:",
      cashBack: "Cashback",
      transactionDate: "Transaction Date:",
      pumpName: "Pump Name:",
      amount: "Amount:",
      charge: "Charge:",
      transactionRef: "Transaction Reference:",
      stan: "Stan:",
      RRN: "RRN:",
      maskedPan: "Masked Pan:",
      customerName: "Customer Name:",
      status: "Status:",
      cardExpiry: "Card expiry:",
      terminalId: "Terminal id:",
      print: "Print",
      providusBank: "PROVIDUS BANK",
      merchantName: "Merchant Name:",
      reprint: "REPRINT",
      dateTime: "DATE/TIME: ",
      amount: "Amount:    ",
      expiryDate: "Exp Date:",
      responseCode: "Response Code:",
      refNumber: "Reference Number:",
      merchantCopy: "Merchant Copy",
      pumpAuth: "Pump authorized by Epump",
      terminalID: "Terminal ID:",
      STAN: "STAN",
    },

    //re-assign pos modal and reassign POS branch
    reAssignPosModal: {
      reAssignPos: "Re-assign POS",
      selectCompany: "Select Company",
      selectBranch: "Select Branch",
    },

    //createTerminalModal
    createTerminalModal: {
      createTerminal: "Create Terminal",
      terminalId: "Terminal ID",
      serialNo: "Serial No",
      bank: "Bank",
      selectBank: "Select bank",
    },

    // truck map
    createTrucksModal: {
      selectCredential: "select credential",
      selectTruck: "select truck",
      licensePlate: "License plate",
      model: "model",
      type: "Type",
      vin: "Vin",
      truckAlias: "Truck Alias",
      brand: "Brand",
      productionDate: "Production Date",
      selectDate: "Select date",
      tankVol: "Tank volume",
      engineNo: "Engine no",
      chasisNo: "Chasis no",
      selectType: "select type",
      truck: "Truck",
      trailer: "Trailer",
      selectProduct: "select product",
      customerVehicleName: "Customer Vehicle Name",
    },

    /***** Industrial Portal */

    // Industrial Master Layout
    iMasterLayout: {
      dashboard: "Dashboard",
      wallet: "Wallet",
      walletBalance: "Wallet Balance",
      transactionsDetails: "Transactions Details",
      orderManagement: "Order Management",
      reports: "Reports",
      consumptionReport: "Usage Report",
      consumptionHistory: "Fuel History",
      tanksFilled: "Products Discharged ",
      events: "Events",
      maintenance: "Maintenance",
      addMaintenance: "Add Maintenance",
      schedules: "Schedules",
      category: "Category",
      addCategory: "Add Category",
      hi: "Hi",
      isRunningOn: "is running on",
      signOut: "Sign Out",
      confirmLogout: "Do you really want to logout?",
    },
    //Maintenance
    maintenance: {
      maintenanceList: "Maintenance List",
      viewMaintList: "View your group maintenance list here...",
      viewRegionMaintenance: "View your region maintenance here...",
      totalMaintenance: "Total Maintenance",
      station: "Station",
    },
    // send report
    sendReport: {
      report: "Report",
      reportdate: "Report Date",
      withAtgOnly: "With ATG only",
      true: "True",
      false: "False",
      forwardReport: "Forward report",
      mailTo: "Mail To",
      enterRecipient: "Enter recipient",
      dateAndTime: "Select date & time",
      dateRange: "Select date range",
      selDatePaid: "Select date paid",
    },
    // Industry Admin Master Layout
    iAdminMasterLayout: {
      dashboard: "Overview",
      branches: "Sites",
      wallet: "Wallet",
      walletBalance: "Wallet Balance",
      transactionsDetails: "Transactions Details",
      orderManagement: "Order Management",
      reports: "Reports",
      consumptionReport: "Consumption Report",
      transactionHistory: "Transaction History",
      tanksFilled: "Products Discharged ",
      events: "Events",
      maintenance: "Maintenance",
      addMaintenance: "Add Maintenance",
      schedules: "Schedules",
      hi: "Hi",
      signOut: "Sign Out",
      confirmLogout: "Do you really want to logout?",
    },
    // Industrial Dashboard
    iDashboard: {
      totalHoursOnPowerGrid: "Total Hours of Power Grid",
      totalHoursOnGenGrid: "Total Hours of Generator",
      hours: "Hours",
      orderFor: "Order for Diesel ",
      order: "Order",
      walletBalance: "Wallet Balance",
      addFunds: "Add Funds",
      currentVolume: "Current Volume",
      maxVolume: "Maximum Volume",
      totalConsumedToday: "Total Volume Consumed Today",
      litres: "Litres",
      hourlyUsage: "Hourly Usage",
      dailyUsage: "Daily Usage",
      monthlyUsage: "Monthly Usage",
      dailyUsageHours: "Daily Usage (Hours)",
      hourlyUsageHours: "Hourly Usage (Hours)",
      monthlyUsageHours: "Monthly Usage (Hours)",
      totalTankDisplacement: "Total Tank Displacement",
      totalTankDisplacementLitres: "Total Tank Displacement (Litres)",
      logoutTip: "Sign Out",
      //INDUSTRIAL ADMIN
      fuelVolume: "Total Volume of Fuel",
      companyWallet: "Total Wallet Balance",
      branchConsumption: "Total Site Consumption",
      allBranches: "All Sites",
      branchesTagline: "Get to know the daily stations reports ",
      totalHours: "Total Hours of Generator",
      tankPercentage: "Tanks with less than 30%",
      allTanks: "See all tanks",
      power: "Power (Hours)",
      generator: "Generator (Hours)",
      fuel: "Fuel (Liters)",
      allBranchConsumption: "See all site's consumption",
      volumeConsumed: "Volume Consumed (Litres)",
      branch: "Branch",
      site: "Site",
      tank: "Tank",
      overview: "Overview",
      powerHours: "Total Hours of Power Grid ",
      waterVol: "Water Volume:",
      //branches
      tankVolume: "Total tank Volume",
      maxVolume: "Max Volume",
      action: "Action",
      //station tank
      tankConsumption: "Tank consumption report",
      companyReportsDetails: "View all details about company reports",
      tank: "Tank",
      currentVolume: "Current Volume",
      maxCapacity: "Maximum Capacity",
    },
    // industrial group management
    iGroupManagement: {
      groupManagement: "Group Management",
      createAndManage: " Create and manage your industry groups here",
      createNew: "CREATE NEW",
      totalGroups: "Total Groups",
      name: "Name",
      description: "Description",
      category: "Category",
      email: "Email",
      action: "Action",
    },

    //industrial maintenance
    iMaintenance: {
      maintenanceTitle: "Maintenance",
      maintenanceForAllBranch: "View maintenance details for all branch",
      allGenerators: "All Generators",
      serviceGenerators: "Generators in need of service",
    },

    //industrial generators
    iGenerators: {
      branch: "Branch",
      site: "Site",
      startedDate: "Started Date",
      totalHours: "Total Hours",
      daysToMaintenance: "Days to Maintenance",
    },
    //industrial order management
    iOrderManagement: {
      orderManagement: "Order Management",
      cumulativeDetails: "Cumulative details of all site orders",
      branch: "Branch",
      site: "Site",
      totalOrder: "Total order",
      quantity: "Quantity (Litre)",
      amount: "Amount",
      action: "Action",
    },

    // industrial order details
    iOrderDetails: {
      individualOrderDetails: "View individual site order details",
      branch: "Branch",
      product: "Product",
      quantity: "Quantity (Litre)",
      amount: "Amount",
      status: "Status",
    },

    // industrial users
    iUsers: {
      title: "Users",
      manageUsers: "Manage users",
      usersAndRoles: "Manage your users and their roles here...",
      createUsers: "Create user",
      addExistingUser: "Add existing user",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      status: "Status",
      accessLevel: "Access level",
      //user details
      phoneNumber: "Phone Number",
      active: "Active",
      deactivated: "Deactivated",
      suspended: "Suspended",
      selectAccessLevel: "Select Access Level",
      selectAccess: "select access level",
      select: "Select",
      passwordChange: "Force password change",
      search: "search...",
      updateUser: "Update user",
      selectRole: "Select All Role",
      roles: "Roles",
      //create user
      createUser: "Create user",
    },

    //industrial wallet
    iWallet: {
      wallet: "Wallet",
      branchOrderHistory: "View site order history and transactions",
      walletOverview: "Wallet Overview",
      transactionDetails: "Transaction Details",
      //transaction details
      amount: "Amount(Naira)",
      status: "Status",
      description: "Description",
      date: "Date",
      // wallet Overview
      walletBalance: "Wallet Balance",
      totalIncome: "Total income For The Past Seven (7) Days",
      totalExpenses: "Total expenses For The Past Seven (7) Days",
    },
    // industrial group
    iGroup: {
      overview: "overview",
      viewOverview: "View overview of the group",
      totalHoursOfGen: "Total hours of generator",
      tanksLessThan: "Tanks less than 30%",
      seeAllTanks: "See all tanks",
      startedDate: "Started Date",
      totalHours: "Total hours",
      daysToMaint: "Days to Maintenance",
      maintenance: "Maintenance",
      viewMaintDetails: "View maintenance details for all branch",
      allGenerators: "All Generators",
      serviceGen: "Generators in need of service",
      viewIndividualBranch: "View individual site order details",
      date: "Date",
      product: "Product",
      quantity: "Quantity(Litre)",
      amount: "Amount",
      status: "Status",
      description: "Description",
      orderManagement: "Order Management",
      cumulativeDetails: "Cumulative details of all site orders",
      totalOrder: "Total order",
      totalHoursOnGen: "Total Hours On Generator",
      litrs: "Litres",
      powerHours: "Power (Hours)",
      genHours: "Generator (Hours)",
      volConsumed: "Volume Consumed (Litres)",
      fuelLitres: "Fuel (Litres)",
      viewBranchHistory: "View site order history and transactions",
      reports: "Reports",
      report: "Report",
      consumption: "Consumption",
      tankReport: "Tank Report",
      totalIncome: "Total income For The Past Seven (7) Days",
      amountNaira: "Amount(Naira)",
      wallet: "Wallet",
      walletBalance: "Wallet Balance",
      walletOverview: "Wallet Overview",
      transactionDetails: "Transaction Details",
      manageUsers: "Manage Users",
      genRequireServicing: "generator(s) that require servicing",
      groupManagement: "Group Management",
      genHours: "Generator hours:",
      branchConsumption: "See all Site's Consumption",
      hours: "hours",
    },
    // industrial station tank
    iBranchTank: {
      tank: "Tank",
      currVolume: "Current Volume",
      maxCapacity: "Maximum Capacity",
      branch: "Branch",
      site: "Site",
      totalTankVolume: "Total Tank volume",
      maxVolume: "Max volume",
      action: "Action",
    },

    // Industrial Events
    iEvents: {
      eventReport: "Event Report",
      getToKnow:
        "Get to know the daily events that occurred in your  building.",
      logBetween: "Events log between",
      date: "Date",
      event: "Event",
      startTime: "Start Time",
      endTime: "End Time",
      source: "Source",
      usageTime: "Usage Time",
    },

    // Industrial Fund Wallet
    iFundWallet: {
      confirmingPayment: "Confirming your payment...",
      paymentConfirmed: "Payment Confirmed!",
      errorConfirming:
        "Error Confirming your payment, Please contact our support team.",
      errorConfirmingStripe:
        "Error Confirming your payment, Please refresh page. If the error persists, check your wallet to see if your funding have reflected before trying to fund wallet again",
      fundWithCard: "Fund with Card",
      wallet: "Wallet",
      fundAccountWithCard: "Fund your Account by paying with your card online",
      payNow: "Pay Now",
      fundAccountWithWallet: "Fund your account with your station Wallet",
      amount: "Amount",
      amountMissing: "Please input an amount",
      fundWithBank: "Fund Account with your Bank",
      bankName: "Bank Name:",
      providusBank: "Providus Bank",
      accountNumber: "Account Number:",
      accountName: "Account Name:",
      clickContinue: "Click continue after you make payment",
      continue: "Continue",
      bank: "Bank",
      card: "Card",
      bankTransfer: "Bank Transfer",
      makePayment: "Make Payment",
      desc: "Make payment with your Bank to update wallet balance",
      desc2:
        "Click refresh icon to check your updated wallet balance and Settle Invoice when amount is updated",
      desc3: "Click refresh icon to view updated wallet balance and",
      payMode: "Payment mode",
      bWallet: "Station Wallet",
      poweredBy: "... powered by",
      inputUSD: "Input Amount in USD($)",
    },

    // Industrial Report
    iReport: {
      dailyReport: "Daily Consumption Report",
      getReport: "Get reports on your daily consumption.",
      consumptionBetween: "Consumption between",
      totalHoursOnPowerGrid: "Total Hours of Power Grid",
      hours: "hours",
      totalHoursOnGenGrid: "Total Hours of Generator",
      totalFuelConsumption: "Total Fuel Consumption",
      litres: "Litres",
      powerDistribution: "Power Distribution",
      generator: "Generator",
      powerGrid: "Power Grid",
      volUsed: "Volume Used",
      dailyUsageChart: "Daily Usage Chart",
      dailyUsageHours: "Daily Usage (Hours)",
      report: "Reports",
      orderHistory: "View site order history and transactions",
      consumption: "Consumption",
      tankReport: "Tank Report",
      tankVolChart: "Tank Volume Chart",
    },

    // Industrial Wallet Transactions
    iWalletTransactions: {
      title: "Wallet Transactions",
      getReports: "Get reports on your total wallet transactions",
      walletTransBtw: "Wallet Transaction Between",
      amount: "Amount {currency}",
      source: "Source",
      status: "Status",
      walletBalance: "Wallet Balance {currency}",
    },

    // Industrial Wallet Balance
    iWalletBalance: {
      title: "Wallet Balance",
      addFunds: "Add Funds",
      totalExpenses: "Total Expenses For The Past Seven (7) Days",
      transactionSummary: "Transaction Summary",
      viewMore: "View More",
      noTransaction: "No Wallet Transactions Yet",
      amount: "Amount {currency}",
      walletStatistics: "Wallet Statistics",
      expenses: "Expenses",
      income: "Income",
    },

    // Track Order
    iTrackOrder: {
      back: "Back",
      statusUpdates: "Status Updates",
      litres: "Litres",
      from: "FROM",
      to: "TO",
      date: "Date",
      comment: "Comment",
      status: "Status",
    },

    // Tanks Filled
    iTanksFilled: {
      title: "Product Discharged",
      getReports: "Get reports on the total tank transactions",
      tanksFilledOn: "Products Discharged on",
      tankName: "Tank Name",
      eVolumeDischarged: "Epump Volume Discharged(ltr)",
      mVolumeDischarged: "Manual Volume Discharged(ltr)",
      variance: "Variance",
      eStartVolume: "Epump Start Volume(ltr)",
      eVolumeEnd: "Epump End Volume(ltr)",
      mStartVolume: "Manual Start Volume(ltr)",
      mEndVolume: "Manual End Volume(ltr)",
      startTime: "Start Time",
      endTime: "End Time",
      noTanksFilledOn: "No Products Discharged  On",
    },

    // Tank Transactions
    iTankTransactions: {
      title: "Tank Consumption Report",
      getReports: "Get reports on the total tank transactions",
      tankReportBtw: "Tanks Report between",
      name: "Name",
      volumeConsumed: "Volume Consumed",
      volumeRefilled: "Volume Refilled",
      openingVolume: "Opening Volume",
      closingVolume: "Closing Volume",
      tanksReport: "Tanks Report",
      totalVolume: "Total Volume (Litres)",
      volumeSold: "Volume Sold",
      volumeFilled: "Volume Filled",
      viewDetailsReports: "View all details about group reports",
      tankReportsOn: "Tank Reports on",
      tankConsumptionSummary: "Tank Consumption Summary",
      volConsumed: "Volume Consumed:",
      volFilled: "Volume Filled:",
      date: "Date",
      volumeUsed: "Volume Used",
    },
    //Industry tanks
    iTanks: {
      tanks: "Tanks",
      waterLevel: "water level",
      probeTransactions: "Probe Transactions",
      dailyReport: "Daily Report",
    },

    //tank details
    iTankDetails: {
      dailyReport: "Tank Daily Report",
      dateRange: "Select a date range",
      tanksFilled: "Tanks Filled between",
      tank: "Tank",
      date: "Date",
      openingVol: "Opening Volume",
      closingVol: "Closing Volume",
      volFilled: "Volume Filled",
      volSold: "Volume Sold",
    },

    //tank probe transactions
    iTankProbe: {
      totalTransactions: "Total Transactions",
      tankProbeTransactions: "Tank Probe Transactions",
      dateRange: "Select a date range",
      tanksFilled: "Tanks Filled between",
      date: "Date",
      productHeight: "Product Height",
      productVolume: "Product Volume",
      temperature: "Temperature",
      waterHeight: "Water Height",
      waterVol: "Water Volume",
    },
    // Service
    service: {
      service: "service",
      serviceName: "Service name",
      addService: "Add service",
      noServiceAdded: "You currently don't have any service added",
      serviceAddition: "services will be added here when added",
      manageService: "Manage Services",
      manageServiceFor: "Manage your services for",
      manageTransFor: "Manage your transactions for",
      viewTrans: "View Transactions",
      totalServices: "Total services",
      totalTrans: "Total transactions",
      totalAmount: "Total amount",
      action: "Action",
      trans: "transactions",
      here: " here",
      totalSoldPrice: "Total sold price",
      date: "Date",
      serviceDesc: "Service description",
      customer: "Customer",
      price: "Price",
      transHistory: "Transaction history",
      recordDate: "Record date",
      manageServiceTrans: "Manage service transactions",
      station: "Station",
      amount: "Amount",
    },

    // Schedule Maintenance
    iScheduleMaintenance: {
      nextMaintenance: "Next Maintenance",
      hi: "Hi",
      youCanFix:
        "You can fix a date and and set a reminder to service your equipment",
      schedule: "Schedule",
      facilityType: "Facility Type",
      facilityName: "Facility Name",
      status: "Status",
      date: "Date",
      dueDate: "Due Date",
      countdown: "Countdown",
      history: "History",
      markAsDone: "Mark As Done",
      hours: "hours",
      day: "day | days",
      expired: "Expired",
      done: "Done",
      pending: "Pending",
      countDown: "Count Down",
    },

    // Maintenance History
    iMaintenanceHistory: {
      back: "Back",
      title: "History",
      nextMaintenance: "Next Maintenance",
      countdown: "Countdown",
      resolvedOn: "Resolved on",
      at: "at",
      cost: "Cost",
      hours: "hours",
      day: "day | days",
      expired: "Expired",
      done: "Done",
      pending: "Pending",
    },
    // Add Maintenance
    iAddMaintenance: {
      scheduleMaintenance: "Schedule Maintenance",
      type: "Type",
      facilityType: "Select Facility Type",
      generator: "Generator",
      tankSystem: "Tank System",
      generatorName: "Generator Name",
      description: "Description",
      maintenanceDescription: "Maintenance Description",
      resolved: "Resolved",
      true: "True",
      false: "False",
      dueDate: "Due Date",
      schedule: "Schedule",
      facilityTypeMissing: "Please select the facility type",
      generatorTypeNameMissing: "Please input a generator type name",
      descriptionMissing: "Please input a description",
      trueOrFalse: "Please select true or false if resolved",
      successfullyAdded: "Successfully Added Schedule",
      category: "Category",
      service: "Service",
    },

    // Request Diesel
    iRequestDiesel: {
      numberOfOrders: "Number of Orders",
      hi: "Hi",
      requestText: "Diesel can be requested to be delievered to you.",
      requestDiesel: "Request Diesel",
      date: "Date",
      volume: "Volume(Liters)",
      price: "Price",
      product: "Product",
      amount: "Amount {currency}",
      status: "Status",
      trackOrder: "Track Order",
      completeOrder: "Complete Order",
    },

    // Add Order & Complete Order
    iAddOrder: {
      confirmingPayment: "Confirming your payment...",
      paymentConfirmed: "Payment Confirmed!",
      errorConfirming: "Error Confirming your payment, Please try again.",
      order: "ORDER",
      shipping: "SHIPPING",
      payment: "PAYMENT",
      fullAddress: "Full Address",
      station: "Station",
      volume: "Volume",
      product: "Product",
      selectAProduct: "Select product",
      addOrder: "Add Order",
      pricePerLitre: "Price Per Liter | Price/Ltr",
      amount: "Amount",
      litreVolume: "Liter Volume",
      litres: "Liters",
      deliveryAddress: "Delivery address",
      previous: "Previous",
      next: "Next",
      payWithCard: "Pay with Card",
      wallet: "Wallet",
      confirmAmount: "Confirm amount and proceed to making your payment",
      payNow: "Pay Now",
      walletDebited: "Your station Wallet Balance would be debited",
      successfullyAdded: "Order Added Successfully, proceed to payment",
      unsuccessfulAdd: "Failed to order",
      amountMissing: "Please input an amount",
      addressMissing: "Please input an address",
      stationMissing: "Please input a station",
      volumeMissing: "Please input a volume",
      productMissing: "Please select a product to continue",
      priceLiter: "Price Per Liter",
      continue: "Continue",
      bank: "Bank",
      fundWithBank: "Fund Account with your Bank",
      makeTransfer: "Make transfer to the account",
      availableBalance: "Available balance is",
    },

    // Mark Maintenance
    iMarkMaintenance: {
      markAsDone: "Mark As Done",
      totalCost: "Total Cost Of Maintenance",
      inputAmount: "Input Amount",
      comment: "Comment",
      updateComment: "Update Comment",
      mark: "Mark",
      amountMissing: "Please input an amount",
      commentMissing: "Please input a comment",
      successfullyCompleted: "Maintenance completed Succesfully",
      successfullyyUpdatedTrack: "Maintenance Track Updated",
      conGraph: "Consumption Range Graph",
    },

    //Reorder Level
    reorderLevel: {
      title: "Reorder Level",
      desc: "View and manage your tank reorder level details here",
      addRe: "Add reorder level",
      editRe: "Edit reorder level",
      selPro: "Select product",
      inputRL: "Input reorder level",
      proCap: "Product capacity",
      deleted: "Reorder level deleted",
      revert: "Revert",
      reverted: "Reverted",
    },

    //Price Manager
    priceManager: {
      title: "Approvals",
      title2: "Station Cluster",
      desc: "View your approvals managers here...",
      desc2: "View your price change approvals here",
      desc3: "View your station cluster here",
      priceChange: "Price change",
      position: "Position",
      missingPosition: "Input position",
      selectUser: "Select user",
      loading: "loading...",
      addPM: "Add approval",
      addedPM: "Added approval",
      updatedPM: "Updated approval",
      updatePM: "Update approval",
      deletedPM: "Deleted approval",
      deletePMWarn: "Are you sure you want to delete approval?",
      approvals: "Approvals",
      decline: "Decline",
      approveWarn: "Are you sure you want to approve?",
      approveSuccess: "Successfully approved",
      declineWarn: "Are you sure you want to decline?",
      declineSuccess: "Successfully declined",
      unauthorized: "Unauthorized",
      level: "Level",
      selectLevel: "Select level",
      selTypeToEnable: "select type to enable",
      submitted: "Submitted",
      reasonFor: "Reason for declining",
      initiatedBy: "Initiated by",
    },

    //Omitted
    omit: {
      stationSalesRep: "STATION SALES REPORT",
      branchAdd: "Station Address",
      dailyGrowth: "Daily Growth",
      totLitTra: "Total Litre per transaction",
      totPmsSold: "Total PMS Sold",
      totAgoSold: "Total AGO Sold",
      totDpkSold: "Total DPK Sold",
      totDisp: "Total Dispensed",
      listGenVou: "List Of Generated Vouchers",
      viewTerList: "View the list of your terminals here",
      allComp: "All Companies",
      allBanks: "All Banks",
      allTerminals: "All Terminals",
      allOwners: "All Owners",
      enterPass: "enter your password",
      enterEmail: "email@email.com",
      showTransfer: "Show transfer",
      hideTransfer: "Hide transfer",
      posTransact: "POS Transactions",
      moMo: "Mobile Money",
      consumptionChart: "Consumption chart",
      backToGroupDash: "Back to Group Dashboard",
      paymentSucceeded: "Payment succeeded!",
      paymentProcessing: "Payment processing!",
      paymentNotSuccessful:
        "Your payment was not successful, please try again.",
      somethingWentWrong: "Something went wrong.",
      unexpectedError: "An unexpected error occurred.",
      checking: "checking...",
      noTanksDisplay: "No Tanks to display",
      deleteTerminal: "Are you sure you want to delete terminal?",
      terminalDeleted: "Successfully deleted terminal",
      successfullyDownloaded: "Successfully downloaded",
      successfullyReassignedPOS: "Successfully re-assigned POS",
      tokenMissing: "Please input your token",
      paymentChannel: "PAYMENT CHANNEL",
      revenue: "REVENUE",
      wetStock: "Wet stock",
      rtt: "RTT",
      is: "is",
      dispensed: "Dispensed",
      esaleSummary: "View your remis sales summary and details here",
      retainershipSummary: "View your retainer sales summary and details here",
      uniqueID: "Unique ID",
      voucherCardNo: "Voucher card No.",
      remisSales: "Remis sales",
      walletTU: "Wallet Top-up",
      avgLtr: "Avg litre per transaction",
      lastUpdated: "and last updated on",
      searchRole: "Search role",
      selectRoles: "Select all roles",
      mappedRoles: "Mapped roles",
      addMappedRoles: "Add roles",
      successfullyUpdatedRole: "Successfully updated subcategory",
      sureToDelete: "Are you sure you want to delete?",
      removeRole: "Are you sure you want to remove",
      removedRoleSuccess: "Successfully removed role",
      mapRolesFor: "Map roles for",
      manageSubcat: "Team Access",
      manageSubcatDet: "View your team access here...",
      upSubcat: "Update team access type",
      addSubcat: "Add team access type",
      mapRoles: "Map Roles",
      priceChangeLog: "Price change log",
      tp: "Throughput",
      tpfor: "ThroughPut for",
      selectSubcat: "Select subcategory",
      openreadThirtyDays: "Opening Reading for last 30 days",
      openreadCurDate: "Opening Reading for current date",
      approve: "Approve",
      approvePrice: "Price Approvals",
      oldPrice: "Old price",
      selectOpenCloseDate: "Select opening and closing date",
      successful: "Successful",
      failed: "Failed",
      payDirect: "Pay Direct",
      directTransfer: "Direct Transfer",
      dataRejected: "Data rejected successfully",
      sureReject: "Are you sure you want to reject record?",
      addRec: "Add Record",
      uploadTI: "Upload Totalizer Image",
      passRequirement: "Password doesn't meet all requirements",
      oneUpper: "Use at least one uppercase letter",
      oneNum: "Use at least one number",
      oneSpec: "Use at least one special character",
      eightChar: "Use at least 8 characters",
      pickOrSearch: "Pick or search to select",
      initialPosting: "Initial posting",
      remisWallet: "Remis wallet",
    },
  },
};
